"use strict";

function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
}

function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
}

function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen)
}

function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter)
}

function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr)
}

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2
}

/* PERF + iPhone-11 memory crash: lazy-load data-src/data-srcset images via IntersectionObserver instead of swapping ALL at once. The homepage has ~134 images (~33MB decoded); loading them all crashed Chrome on iPhone 11 (low VRAM). TWO tiers (28 Aug, measured with tools/pkg13-scrollblank.js): the near band (300px) swaps at normal priority as before, and a far band (1600px, ~2 viewports) prefetches at fetchpriority=low so a fast flick finds its landing images already in flight WITHOUT the prefetches stealing bandwidth from whatever is on screen — a flat 1600px band tested WORSE on a slow pipe (5.2s vs 4.8s landing blank) precisely because of that contention; same reason the gallery warm below uses low. A still-loading prefetch that reaches the near band is bumped back to high. Decoded memory stays a small rolling set, nothing like the swap-all crash. Falls back to load-all if IntersectionObserver is unavailable. */
var dataImages = document.querySelectorAll("img[data-src], img[data-srcset]");
(function () {
    var swapImg = function (img) {
        var pic = img.parentNode;
        if (pic && pic.tagName === "PICTURE") {
            var srcs = pic.querySelectorAll("source[data-srcset]");
            for (var j = 0; j < srcs.length; j++) { srcs[j].setAttribute("srcset", srcs[j].getAttribute("data-srcset")); srcs[j].removeAttribute("data-srcset"); }
        }
        img.decoding = "async"; /* decode off the main thread so mid-scroll arrivals don't jank the frame */
        if (img.getAttribute("data-src")) { img.removeAttribute("src"); img.setAttribute("src", img.getAttribute("data-src")); }
        if (img.getAttribute("data-srcset")) { img.removeAttribute("srcset"); img.setAttribute("srcset", img.getAttribute("data-srcset")); }
        img.onload = function () { img.removeAttribute("data-src"); img.removeAttribute("data-srcset"); };
    };
    /* sources whose <img> is NOT lazy (already has a real src) would never be triggered -> swap them now so they don't stay on the placeholder */
    var orphanSources = document.querySelectorAll("picture > source[data-srcset]");
    for (var s = 0; s < orphanSources.length; s++) {
        var im = orphanSources[s].parentNode.querySelector("img");
        if (im && !im.getAttribute("data-src") && !im.getAttribute("data-srcset")) { orphanSources[s].setAttribute("srcset", orphanSources[s].getAttribute("data-srcset")); orphanSources[s].removeAttribute("data-srcset"); }
    }
    if (!("IntersectionObserver" in window) || !dataImages || !dataImages.length) {
        if (dataImages) dataImages.forEach(swapImg);
        return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
        for (var k = 0; k < entries.length; k++) {
            if (!entries[k].isIntersecting) continue;
            var im = entries[k].target;
            if (im.getAttribute("data-src") || im.getAttribute("data-srcset")) { swapImg(im); }
            else if (!im.complete) { im.setAttribute("fetchpriority", "high"); } /* far-tier prefetch still in flight but now (nearly) visible */
            obs.unobserve(im);
        }
    }, { rootMargin: "300px 0px" });
    var ioFar = new IntersectionObserver(function (entries, obs) {
        for (var k = 0; k < entries.length; k++) {
            if (!entries[k].isIntersecting) continue;
            var im = entries[k].target;
            if (im.getAttribute("data-src") || im.getAttribute("data-srcset")) { im.setAttribute("fetchpriority", "low"); swapImg(im); }
            obs.unobserve(im);
        }
    }, { rootMargin: "1600px 0px" });
    dataImages.forEach(function (img) { io.observe(img); ioFar.observe(img); });
})();
var isMobileViewport = window.innerWidth < 1024;
var isSafariBrowser = !!(window.global && window.global.isSafariBrowser);
if (isSafariBrowser) {
    document.documentElement.classList.add("safari-scroll-compat");
    document.body.classList.add("safari-scroll-compat")
}
var initSmoothScroll = window.global.initSmoothScroll;
var scheduledScrollTasks = [];
var scheduledResizeTasks = [];
var isScrollTaskQueued = false;
var isResizeTaskQueued = false;

function runScheduledTasks(tasks) {
    tasks.forEach(function (task) {
        return task()
    })
}

function requestScheduledTaskFrame(tasks, type) {
    if (type === "scroll") {
        if (isScrollTaskQueued) return;
        isScrollTaskQueued = true;
        requestAnimationFrame(function () {
            isScrollTaskQueued = false;
            runScheduledTasks(tasks)
        });
        return
    }
    if (isResizeTaskQueued) return;
    isResizeTaskQueued = true;
    requestAnimationFrame(function () {
        isResizeTaskQueued = false;
        runScheduledTasks(tasks)
    })
}

function registerScrollTask(task, runImmediately) {
    if (typeof task !== "function") return;
    scheduledScrollTasks.push(task);
    if (runImmediately !== false) {
        task()
    }
}

function registerResizeTask(task, runImmediately) {
    if (typeof task !== "function") return;
    scheduledResizeTasks.push(task);
    if (runImmediately !== false) {
        task()
    }
}

function smoothScrollToPosition(top) {
    var nextTop = Math.max(0, Math.round(top));
    if (window.lenis && !isSafariBrowser && typeof window.lenis.scrollTo === "function") {
        window.lenis.scrollTo(nextTop);
        return
    }
    window.scrollTo({top: nextTop, left: 0, behavior: "smooth"})
}

function getAbsoluteElementTop(element) {
    if (!element) return 0;
    return element.getBoundingClientRect().top + document.documentElement.scrollTop
}

function toggleSafariHelicopterPadState() {
    if (!isSafariBrowser || isMobileViewport) return;
    var helicopter = document.querySelector(".helicopter");
    var helicopterPad = document.querySelector(".subscribe_section-helicopter");
    var helipad = document.querySelector(".subscribe_section-helipad");
    if (!helicopter || !helicopterPad || !helipad) return;
    if (window.getComputedStyle(helipad).display === "none") return;
    var helipadRect = helipad.getBoundingClientRect();
    var helipadCenterY = helipadRect.top + helipadRect.height / 2;
    var viewportCenterY = window.innerHeight / 2;
    var isPastHelipadThreshold = helipadCenterY <= viewportCenterY;
    helicopter.style.display = isPastHelipadThreshold ? "none" : "block";
    if ($(".about_page").length || isPastHelipadThreshold) {
        helicopterPad.classList.add("show");
        return
    }
    helicopterPad.classList.remove("show")
}

function syncHelicopterPadStateOnResize() {
    /* Mobile: the helicopter is position:absolute and scrolls away on its own — never
       display-toggle it here. On mobile every scroll fires a resize (the URL bar), so this
       would hide it from a momentary scroll position and never restore it. */
    if (window.matchMedia("(max-width: 1024px)").matches) return;
    var helicopter = document.querySelector(".helicopter");
    var helicopterLine = document.querySelector(".helicopter-line");
    var helicopterPad = document.querySelector(".subscribe_section-helicopter");
    if (!helicopter || !helicopterPad) return;
    if (window.getComputedStyle(helicopterPad).display === "none") return;
    var helicopterPadRect = helicopterPad.getBoundingClientRect();
    var helicopterPadCenterY = helicopterPadRect.top + helicopterPadRect.height / 2;
    var viewportCenterY = window.innerHeight / 2;
    var isPastHelicopterPadThreshold = helicopterPadCenterY <= viewportCenterY;
    helicopter.style.display = isPastHelicopterPadThreshold ? "none" : "block";
    if (helicopterLine) {
        helicopterLine.style.display = isPastHelicopterPadThreshold ? "none" : "block"
    }
    if ($(".about_page").length || isPastHelicopterPadThreshold) {
        helicopterPad.classList.add("show");
        return
    }
    helicopterPad.classList.remove("show")
}

window.addEventListener("scroll", function () {
    requestScheduledTaskFrame(scheduledScrollTasks, "scroll")
}, {passive: true});
window.addEventListener("resize", function () {
    requestScheduledTaskFrame(scheduledResizeTasks, "resize")
});
if (!isMobileViewport && !isSafariBrowser) {
    /* PERF (desktop TBT): defer Lenis smooth-scroll init OUT of the page-load window — its rAF loop is continuous main-thread work that inflates TBT. requestIdleCallback runs it once the main thread is free (native scroll applies until then). Lenis is NOT wired to ScrollTrigger (verified), so no desync. */
    if (window.requestIdleCallback) { requestIdleCallback(function () { initSmoothScroll(); }, { timeout: 3000 }); } else { window.addEventListener("load", function () { setTimeout(initSmoothScroll, 300); }); }
}
gsap.registerPlugin(ScrollTrigger);
/* Lazy-loaded images grow the page as you scroll, and ScrollTrigger caches trigger
   positions without re-reading them — the landing fired ~700px early. Refresh on every
   <img> load, coalesced per frame. Capture phase: 'load' does not bubble. */
if (window.ScrollTrigger && typeof ScrollTrigger.refresh === 'function') {
    var __stRefreshScheduled = false;
    document.addEventListener('load', function (e) {
        if (e.target && e.target.tagName === 'IMG' && !__stRefreshScheduled) {
            __stRefreshScheduled = true;
            requestAnimationFrame(function () { __stRefreshScheduled = false; ScrollTrigger.refresh(); });
        }
    }, true);
}
gsap.registerPlugin(Draggable, InertiaPlugin);// Text animation
var _window$global = window.global, initPreTitles = _window$global.initPreTitles,
    initTitles = _window$global.initTitles, initTitlesAnimation = _window$global.initTitlesAnimation,
    initAboutTitle = _window$global.initAboutTitle, collectionsSlider = _window$global.collectionsSlider,
    initRecommendedPostsSlider = _window$global.initRecommendedPostsSlider, initSound = _window$global.initSound;
initPreTitles();
initTitles();
if (!isMobileViewport) {
    initTitlesAnimation()
}
initSound();
document.addEventListener("DOMContentLoaded", function () {
    var delay = cookie.isPreloader === undefined || cookie.isPreloader === "true" ? preloaderTime + preloaderDelay + 400 : 1400;
    setTimeout(function () {
        initAboutTitle()
    }, delay)
});

function initAOS() {
    /* PERF: AOS.init disabled — replaced by the lightweight reveal in theme.liquid (aos.css removed). Contact-title reveal kept below. */
    var contactTitles = document.querySelectorAll(".contacts-title, .contacts-link-animate");
    contactTitles === null || contactTitles === void 0 || contactTitles.forEach(function (title) {
        return title.classList.add("show")
    })
}

if (cookie.isPreloader === undefined || cookie.isPreloader === "true") {
    setTimeout(function () {
        initAOS()
    }, preloaderTime + preloaderDelay)
} else {
    setTimeout(function () {
        initAOS()
    }, 1200)
}
$(document).ready(function () {
    $(".js-scroll-to").on("click", function (e) {
        e.preventDefault();
        var href = $(this).attr("href");
        if ($(href).length) {
            var scrollToPos = $(href).offset().top + $(".header").innerHeight();
            smoothScrollToPosition(scrollToPos)
        }
    });/* - - - - - - - - - - - - - -       init article-gallery-slider   - - - - - - - - - - - - - - - */
    var sliderBlock = document.querySelector(".article-gallery-slider");
    var swiperContentPageSlider = new Swiper(".article-gallery-slider", {
        navigation: {
            nextEl: ".article-gallery-slider-button-next",
            prevEl: ".article-gallery-slider-button-prev"
        },
        height: "auto",
        slidesPerView: 1,
        spaceBetween: 120,
        loop: "true",
        loopAdditionalSlides: 3,
        speed: 400,
        breakpoints: {
            2200: {slidesPerView: 1, spaceBetween: 220},
            1700: {slidesPerView: 1, spaceBetween: 160},
            1320: {slidesPerView: 1, spaceBetween: 120},
            1200: {slidesPerView: 1, spaceBetween: 100},
            576: {slidesPerView: 1, spaceBetween: 30},
            0: {slidesPerView: 1, spaceBetween: 20}
        }
    });
    $(".article-gallery-slider-button-prev").on("click", function () {
        swiperContentPageSlider.slidePrev()
    });
    $(".article-gallery-slider-button-next").on("click", function () {
        swiperContentPageSlider.slideNext();
        swiperContentPageSlider.updateSlides();
        swiperContentPageSlider.updateProgress()
    })
});

var scrollZoomImageList = document.querySelectorAll(".js-scroll-zoominout");

function scrollZoomInOutImg() {
    if (scrollZoomImageList.length) {
        scrollZoomImageList.forEach(function (item) {
            var posStart = window.innerHeight, posEnd = parseInt("-" + item.offsetHeight),
                currentPos = parseInt(item.getBoundingClientRect().top), image = item.querySelector("img"),
                scaleMax = 1.25;
            image.style.transition = "none";
            if (currentPos <= posStart && currentPos >= posEnd) {
                var dycurrent = parseInt((1 - (currentPos + Math.abs(posEnd)) / (posStart + Math.abs(posEnd))) * 100);
                var scaleImg = 1 + (100 - Math.abs(50 - dycurrent) * 2) / 100 * (scaleMax - 1);
                image.style.transform = "scale(".concat(scaleImg, ")")
            } else {
                image.style.transform = "scale(1)"
            }
        })
    }
}

if (!isMobileViewport) {
    scrollZoomInOutImg()
}
gsap.registerPlugin(ScrollTrigger);

function imageZoom(containerClass) {
    var allContainers = $(containerClass);
    if (allContainers.length) {
        allContainers.each(function (index, elem) {
            var img, lens, result, cx, cy;
            img = elem.querySelector("img");
            lens = elem.querySelector(".img-zoom-lens");
            result = elem.querySelector(".img-zoom-result");
            if (!lens) {/* Create lens: */
                lens = document.createElement("DIV");
                lens.setAttribute("class", "img-zoom-lens")
            }
            if (!result) {/* Create result: */
                result = document.createElement("DIV");
                result.setAttribute("class", "img-zoom-result")
            }/* Insert lens: */
            img.parentElement.insertBefore(lens, img);
            img.parentElement.insertBefore(result, img);/* Calculate the ratio between result DIV and lens: */
            cx = elem.offsetWidth / lens.offsetWidth;
            cy = elem.offsetHeight / lens.offsetHeight;/* Set background properties for the result DIV */
            /* Zoom background is applied on FIRST HOVER from data-zoom-src (2000px), not at init:
               setting background-image is what triggers the download, so deferring this line is the
               whole mechanism. Geometry comes from the laid-out img.width/height, not the file.
               Two stacked layers: the :hover CSS hides the base img, and a background layer that is
               still downloading paints as transparent — writing the 2000px URL alone left the pane
               fully blank for the whole download. The already-loaded gallery image underneath keeps
               the pane filled; the browser paints the 2000px layer over it the moment it arrives.
               The single background-size/position values repeat onto both layers, so the swap is a
               pure in-place sharpen. */
            var zoomApplied = false;

            function applyZoomBackground() {
                if (zoomApplied) {
                    return
                }
                zoomApplied = true;
                var zoomSrc = img.getAttribute("data-zoom-src");
                var seed = img.currentSrc || img.src;
                if (zoomSrc && seed && seed !== zoomSrc && seed.indexOf("data:") !== 0) {
                    result.style.backgroundImage = "url('" + zoomSrc + "'), url('" + seed + "')"
                } else {
                    result.style.backgroundImage = "url('" + (zoomSrc || seed) + "')"
                }
            }

            elem.addEventListener("mouseenter", applyZoomBackground);
            result.style.backgroundSize = img.width * cx + "px " + img.height * cy + "px";/* Execute a function when someone moves the cursor over the image, or the lens: */
            lens.addEventListener("mousemove", function (e) {
                cx = elem.offsetWidth / lens.offsetWidth;
                cy = elem.offsetHeight / lens.offsetHeight;
                moveLens(e, img, result, lens, cx, cy)
            });
            elem.addEventListener("mousemove", function (e) {
                cx = elem.offsetWidth / lens.offsetWidth;
                cy = elem.offsetHeight / lens.offsetHeight;
                moveLens(e, img, result, lens, cx, cy)
            });/* And also for touch screens: */ // This code breaks page scroll on mobile
// lens.addEventListener( 'touchmove', ( e ) => moveLens( e, img, result, lens, cx, cy ) );
// elem.addEventListener( 'touchmove', ( e ) => moveLens( e, img, result, lens, cx, cy ) );
        })
    }
}

function moveLens(e, img, result, lens, cx, cy) {
    var pos, x, y;/* Prevent any other actions that may occur when moving over the image */
    e.preventDefault();/* Get the cursor's x and y positions: */
    pos = getCursorPos(e, img);/* Calculate the position of the lens: */
    x = pos.x - lens.offsetWidth / 2;
    y = pos.y - lens.offsetHeight / 2;/* Prevent the lens from being positioned outside the image: */
    if (x > img.width - lens.offsetWidth) {
        x = img.width - lens.offsetWidth
    }
    if (x < 0) {
        x = 0
    }
    if (y > img.height - lens.offsetHeight) {
        y = img.height - lens.offsetHeight
    }
    if (y < 0) {
        y = 0
    }/* Set the position of the lens: */
    lens.style.left = x + "px";
    lens.style.top = y + "px";/* Display what the lens "sees": */
    result.style.backgroundPosition = "-" + x * cx + "px -" + y * cy + "px"
}

function getCursorPos(e, img) {
    var a, x = 0, y = 0;
    e = e || window.event;/* Get the x and y positions of the image: */
    a = img.getBoundingClientRect();/* Calculate the cursor's x and y coordinates, relative to the image: */
    x = e.pageX - a.left;
    y = e.pageY - a.top;/* Consider any page scrolling: */
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return {x: x, y: y}
}

function initPreloaderTransition() {
    var isPreloader = sessionStorage.getItem("isPreloader");
    if (isPreloader === "true") {
        var tl = gsap.timeline();
        reloadSection.style.opacity = 0;
        setTimeout(function () {
            tl.fromTo(reloadSection, {top: "100px", opacity: 0, duration: 0.5}, {top: 0, opacity: 1});
            tl.fromTo(reloadOverflow, {y: 0, opacity: 1, zIndex: 49, duration: 0.5}, {y: "-100%"}, "-=0.5")
        }, 500)
    } else {
        document.querySelector(".reload-overflow").classList.add("hidden");
        sessionStorage.setItem("isPreloader", "true")
    }
}

var reloadOverflow = document.querySelector(".reload-overflow");
var reloadSection = document.querySelector(".header").nextElementSibling;
var headerNav = document.querySelector(".header_nav");
reloadSection.style.transition = "all 0s";
if (sessionStorage.getItem("isReloaded")) {
    if (sessionStorage.getItem("isReloaded") === "true") {// console.log('Сторінка була перезавантажена');
// document.body.classList.remove('show-reload');
    } else {
        sessionStorage.setItem("isReloaded", "true");// console.log('Це перехід з іншої сторінки');
// document.body.classList.add('show-reload');
    }
}

function animateReload(link, event) {
    var isReload = true;
    var submenus = document.querySelectorAll(".menu_bar .show-submenu .submenu");// if ( window.matchMedia( '(max-width: 1199px)' ).matches ) {
    if (link.getAttribute("href") === "" || link.getAttribute("href").startsWith("#") || ~link.getAttribute("href").indexOf("javascript")) {
        isReload = false
    }
    if (link.classList.contains("js-noreload")) {
        isReload = false
    }
    if (link.getAttribute("data-fancybox") !== null || link.getAttribute("data-fancybox-video") !== null) {
        isReload = false
    }
    if (!link.getAttribute("target") && isReload) {
        event.preventDefault();
        document.body.classList.add("no-scroll");
        headerNav.classList.add("prevent");
        submenus === null || submenus === void 0 || submenus.forEach(function (submenu) {// submenu.classList.remove('show-submenu')
            submenu.remove()
        });
        reloadOverflow.classList.add("beforeunload");
        var tl = gsap.timeline();
        tl.fromTo(reloadSection, {top: 0, opacity: 1, duration: 0.5}, {top: "-100px", opacity: 0});
        tl.fromTo(reloadOverflow, {y: "100%", duration: 0.5}, {y: 0}, "-=0.5");
        setTimeout(function () {// window.location.replace( link.getAttribute( 'href' ) );
            window.location.href = link.getAttribute("href")
        }, 1000)
    }
}

var links = document.querySelectorAll("a");
links.forEach(function (link) {
    var isPhone = link.href.includes("tel:");
    var isEmail = link.href.includes("mailto:");
    !isPhone && !isEmail && link.addEventListener("click", function (event) {
        animateReload(link, event)
    }, false)
});
initPreloaderTransition();
$(document).ready(function () {
    /* - - - - - - - - - - - - - -       normalize scroll       - - - - - - - - - - - - - - - */
    $(document).on("wheel mousewheel DOMMouseScroll touchmove", ".js-normal-scroll, .select2-results, .fancybox-slide", function (e) {
        e.stopPropagation()
    });
    if (!isMobileViewport) {
        registerScrollTask(scrollZoomInOutImg, false)
        registerResizeTask(scrollZoomInOutImg, false)
    }

    function setColorHelicopter() {
        var helicopter = document.querySelector(".helicopter");
        var helicopterLine = document.querySelector(".helicopter-line");
        var helicopterPad = document.querySelector(".subscribe_section-helicopter");
        var hlight = gsap.utils.toArray(".h-light");
        hlight.forEach(function (item) {
            gsap.from(item, {
                scrollTrigger: {
                    trigger: item,
                    start: "top center",
                    end: "bottom center",
                    toggleClass: {targets: ".helicopter", className: "light"},
                    invalidateOnRefresh: true
                }
            })
        });
        var hcolorful = gsap.utils.toArray(".h-colorful");
        hcolorful.forEach(function (item) {
            gsap.from(item, {
                scrollTrigger: {
                    trigger: item,
                    start: "top center",
                    end: "bottom center",
                    toggleClass: {targets: ".helicopter", className: "colorful"},
                    invalidateOnRefresh: true
                }
            })
        });
        /* Do NOT gate the landing trigger on the helicopter's opacity: preloaderDelay is 0 now,
           so this runs mid-fade and parseInt(opacity)===0 killed the timeline outright.
           Opacity here is a load-time artifact; the trigger fires much later. */
        if (!isSafariBrowser && $(".subscribe_section-helipad").length && $(".subscribe_section-helipad").css("display") !== "none") {
            gsap.timeline({
                scrollTrigger: {
                    trigger: ".subscribe_section-helipad",
                    start: "center center",
                    end: "center center",
                    scrub: 0,
                    invalidateOnRefresh: true,// markers: true,
                    onEnter: function onEnter(_ref) {
                        var progress = _ref.progress, direction = _ref.direction, isActive = _ref.isActive;
                        helicopter.style.display = "none";
                        helicopterLine.style.display = "none";
                        helicopterPad.classList.add("show")
                    },
                    onEnterBack: function onEnterBack(_ref2) {
                        var progress = _ref2.progress, direction = _ref2.direction, isActive = _ref2.isActive;
                        helicopter.style.display = "block";
                        helicopterLine.style.display = "block";
                        if (!$(".about_page").length) {
                            helicopterPad.classList.remove("show")
                        }
                    }
                }
            })
        }
    }/* - - - - - - - - - - - - - -       fixed helicopter       - - - - - - - - - - - - - - - */
    function fixedHelicopter() {
        if (window.matchMedia("(max-width: 1024px)").matches || $(".about_page").length) {
            helicopter.classList.add("fixed");
            if ($(".about_page").length) {
                $(".subscribe_section-helicopter").addClass("show")
            }
        } else {
            helicopter.classList.remove("fixed")
        }
    }/* - - - - - - - - - - - - - -       hide helicopter       - - - - - - - - - - - - - - - */
    function hideHelicopter() {
        if (!$(".home_container").length) {
            helicopter.classList.add("hide")
        }
    }

    if (typeof helicopter !== "undefined") {
        if (cookie.isPreloader === undefined || cookie.isPreloader === "true") {
            setTimeout(function () {
                fixedHelicopter();
                $(window).on("resize", fixedHelicopter);
                hideHelicopter();
                if (!isMobileViewport) {
                    setColorHelicopter()
                }
                if (isSafariBrowser) {
                    toggleSafariHelicopterPadState()
                }
            }, preloaderTime + preloaderDelay)
        } else {
            fixedHelicopter();
            $(window).on("resize", fixedHelicopter);
            hideHelicopter();
            setTimeout(function () {
                if (!isMobileViewport) {
                    setColorHelicopter()
                }
                if (isSafariBrowser) {
                    toggleSafariHelicopterPadState()
                }
            }, 1000)
        }
    }/* - - - - - - - - - - - - - -       get line distance       - - - - - - - - - - - - - - - */
    function getDistance(x1, y1, x2, y2) {
        return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2))
    }/* - - - - - - - - - - - - - -       set helicopter line       - - - - - - - - - - - - - - - */
    var $helicopter = $(".helicopter");
    var $helicopterLine = $(".helicopter-line");
    var $helicopterLineNode = $helicopterLine.find("line");
    var $helicopterPhotos = $(".helicopter-photo");
    var isAboutPage = $(".about_page").length;

    function setHelicopter() {
        if (!$helicopterLineNode.length) return;
        var viewportWidth = window.innerWidth;
        var viewportHeight = window.innerHeight;
        var top = window.scrollY;
        var x1 = viewportWidth / 2;
        var y1 = viewportHeight / 2 + 15;
        var x2 = x1;
        var y2 = y1;
        if ($helicopter.css("display") === "block" && !isAboutPage) {
            $helicopterLine.css("display", "")
        } else {
            $helicopterLine.css("display", "none")
        }
        $helicopterLineNode.attr("x1", x1).attr("y1", y1).attr("x2", x2).attr("y2", y2);
        var photoArr = [];
        $helicopterPhotos.each(function (i, item) {
            photoArr[i] = {
                photo: item,
                x2: parseInt($(item).offset().left + $(item).innerWidth() / 2),
                y2: parseInt($(item).offset().top - top + $(item).innerHeight() / 2)
            }
        });
        photoArr.sort(function (a, b) {
            return a.y2 - b.y2
        });
        photoArr.map(function (photo, i) {
            x2 = photo.x2;
            y2 = photo.y2;
            var distance = parseInt(getDistance(x1, y1, x2, y2));
            if (distance < viewportWidth / 2 && y2 - y1 < viewportHeight * 0.3 && y1 < y2) {
                $helicopterLineNode.attr("x2", x2).attr("y2", y2);
                $helicopterLineNode.css({"stroke-dasharray": distance, "stroke-dashoffset": distance});
                $helicopterLineNode.addClass("show");
                $(photo.photo).addClass("show-coords")
            } else {
                $(photo.photo).removeClass("show-coords");// console.log('end')
            }
        })
    }

    if (!isMobileViewport && !isSafariBrowser) {
        setHelicopter();
        registerScrollTask(setHelicopter, false);
        registerResizeTask(setHelicopter, false)
    } else if (isSafariBrowser) {
        toggleSafariHelicopterPadState();
        registerScrollTask(toggleSafariHelicopterPadState, false);
        registerResizeTask(toggleSafariHelicopterPadState, false)
    }
    registerResizeTask(syncHelicopterPadStateOnResize, false)

    function getVideo() {
        var $video = $(".player_wrapper video")[0];
        var $videoLine = $(".player_track-line");
        var $videoProgress = $(".player_track-progress");
        var duration = $video.duration;
        var currentTime = 0;
        var step = 10;
        var stepCount = Math.floor(duration / step);
        var stepPercent = step * 100 / duration;
        for (var i = 0; i <= stepCount; i++) {
            $videoLine.append("<span style=\"left: ".concat(stepPercent * i, "%\">").concat(step * i, "</span>"))
        }
        $videoLine.css("background-size", "".concat(stepPercent * 2, "% 100%"));
        setInterval(function () {
            currentTime = $video.currentTime;
            $videoProgress.css("width", "".concat(currentTime * 100 / duration, "%"))
        }, 100);
        if (isNaN(duration)) {
            setTimeout(getVideo, 1000)
        }
    }

    $(document).on("click", ".player_wrapper video", function () {
        var $video = $(this)[0];
        var $player = $(this).closest(".player_wrapper");
        var $videoPlay = $player.find(".player_play");
        if ($video.paused) {
            $videoPlay.removeClass("pause");
            $video.play()
        } else {
            $videoPlay.addClass("pause");
            $video.pause()
        }
    });
    $(document).on("click", ".js-player-play", function () {
        var $this = $(this);
        var $player = $this.closest(".player_wrapper");
        var $video = $player.find("video")[0];
        if ($video.paused) {
            $this.removeClass("pause");
            $video.play()
        } else {
            $this.addClass("pause");
            $video.pause()
        }
    });
    $(document).on("click", ".js-player-sound", function () {
        var $this = $(this);
        var $player = $this.closest(".player_wrapper");
        var $video = $player.find("video")[0];
        if ($video.muted) {
            $this.removeClass("muted");
            $video.muted = false
        } else {
            $this.addClass("muted");
            $video.muted = true
        }
    });

    function playVideo($video) {
        $video.muted = true;
        $video.play();
        $(".player_play").removeClass("pause")
    }

    function pauseVideo($video) {
        $video.pause();
        $video.muted = false;
        $(".player_play").addClass("pause");
        $(".player_sound").addClass("muted")
    }// if ($(".player_wrapper video").length) {
    if (!isMobileViewport && $(".player_wrapper video").length) {
        gsap.timeline({
            scrollTrigger: {
                trigger: ".player_wrapper",
                start: "top center",
                end: "bottom center",
                once: true,
                onEnter: function onEnter(self) {
                    var $video = self.trigger.querySelector("video");
                    var sources = $video.querySelectorAll("source");
                    sources.forEach(function (source) {
                        var dataSrc = source.getAttribute("data-src");
                        if (dataSrc) {
                            source.setAttribute("src", dataSrc)
                        }
                    });
                    $video.load();
                    $video.addEventListener("loadeddata", function () {
                        getVideo();
                        playVideo($video)
                    }, {once: true})
                }
            }
        })
    }

    function pxToRem(val) {
        return val / 16 * 1
    }

    function createPopOver(height, width, paddings) {
        var popover = document.createElement("div");
        popover.classList.add("popover");
        popover.style.position = "absolute";
        popover.style.left = 0;
        popover.style.top = "".concat(-paddings, "px");
        popover.style.width = "".concat(width, "px");
        popover.style.height = "".concat(height + (paddings || 0), "px");
        return popover
    }/* - - - - - - - - - - - - - -       init home page banner       - - - - - - - - - - - - - - - */ //const pageMainBanner = document.querySelector( '.home_content' );
    var pageMainBannerSlider = document.querySelector(".home_container-slider");
    var helikopterTrack = document.querySelector(".home_content");
    var mainBannerSliderAdditional = document.querySelector(".slider_additional");
    if (pageMainBannerSlider && helikopterTrack) {
        setMainBannerSizes();
        window.addEventListener("resize", function () {
            setMainBannerSizes()
        })
    }

    function setMainBannerSizes() {//pageMainBanner.style.height = window.innerHeight + 'px';
    }/* - - - - - - - - - - - - - -       init header nav       - - - - - - - - - - - - - - - */
    var fillHeaderWrapperPage = document.querySelector(".wrapper.fill_header");
    var topBar = document.querySelector(".header  .top_bar");
    var desktopHeader = document.querySelector(".header_nav");
    var desktopNavigationMenuList = document.querySelector(".header_nav .navigation nav ul");
    var mobileHeader = document.querySelector(".header_nav-mobile");
    var mobileMenu = document.querySelector(".header_nav-mobile-inner");
    var burgerButton = document.querySelector(".mobile_header-activity-menu");
    var mobileSideMenu = document.querySelector(".header_nav-mobile_sidemenu");
    var mobileSideMenuInner = document.querySelector(".header_nav-mobile_sidemenu-inner");
    var mobileHeaderTexture = document.querySelector(".mobile_header-texture");

    // The menu's map texture ships with no CSS background (it cost 90 KB on every page load
    // for a closed menu). First burger touch/open applies it from data-texture; the touchstart
    // warm starts the download ~100-300ms before the click lands.
    function applyMenuTexture() {
        if (mobileHeaderTexture && !mobileHeaderTexture.style.backgroundImage && mobileHeaderTexture.dataset.texture) {
            mobileHeaderTexture.style.backgroundImage = 'url("' + mobileHeaderTexture.dataset.texture + '")'
        }
    }
    var headerPrevScrollPos = window.pageYOffset;
    var pageTopPadding = document.querySelector(".page_top_padding");
    var isSidemenuOpen = false;
    var isHeaderWhite = false;
    var touchstartX = 0;
    var touchendX = 0;

    function headerScroll() {
        var currentScrollPos = window.pageYOffset;
        if (currentScrollPos === 0) {
            desktopHeader.classList.remove("header-white");
            mobileHeader.classList.remove("header-white");
            isHeaderWhite = false
        } else if (headerPrevScrollPos <= currentScrollPos) {
            desktopHeader.classList.add("header-white");
            mobileHeader.classList.add("header-white");
            isHeaderWhite = true
        }
        headerPrevScrollPos = window.pageYOffset
    }

    function setPagePadding() {
        if (!pageTopPadding) {
            return
        }
        var topHeaderMobileHeight = $(mobileHeader).innerHeight();
        var topHeaderDesktopHeight = $(desktopHeader).innerHeight();
        if (window.innerWidth < 990) {
            pageTopPadding.style.paddingTop = topHeaderMobileHeight + "px"
        } else {
            pageTopPadding.style.paddingTop = topHeaderDesktopHeight + "px"
        }
    }

    function toggleSidebar() {
        isSidemenuOpen = !isSidemenuOpen;
        if (burgerButton) {
            burgerButton.setAttribute("aria-expanded", isSidemenuOpen ? "true" : "false")
        }
        if (isSidemenuOpen) {
            applyMenuTexture();
            mobileHeader.classList.remove("header-white");
            if (fillHeaderWrapperPage) {
                fillHeaderWrapperPage.classList.remove("fill_header")
            }
        } else if (isHeaderWhite) {
            mobileHeader.classList.add("header-white");
            if (fillHeaderWrapperPage) {
                fillHeaderWrapperPage.classList.add("fill_header")
            }
        } else if (fillHeaderWrapperPage) {
            fillHeaderWrapperPage.classList.add("fill_header")
        }
        if (window.lenis) {
            isSidemenuOpen ? window.lenis.stop() : window.lenis.start()
        }
        mobileSideMenu.classList.toggle("sidemenu-open");
        document.body.classList.toggle("overflow-hidden")
    }

    function checkDirection() {
        if (touchendX + 100 < touchstartX) {
            toggleSidebar()
        }
    }

    if (desktopHeader && mobileHeader && burgerButton && mobileSideMenu) {
        var topHeaderMobileHeight = $(mobileHeader).innerHeight();
        mobileSideMenu.style.height = window.innerHeight + "px";// mobileSideMenuInner.style.height = `calc(100svh - ${topHeaderMobileHeight}px)`;
        mobileSideMenuInner.style.height = "".concat(window.innerHeight - topHeaderMobileHeight, "px");
        setPagePadding();
        headerScroll();
        if (!isMobileViewport) {
            registerScrollTask(headerScroll, false)
        }
        window.addEventListener("resize", function () {
            /* Widening past the mobile breakpoint with the side menu open left it open forever:
               CSS hides the burger, so nothing can call toggleSidebar again, and its cleanup
               (fill_header, body scroll lock, lenis.start) never runs — the header lost its
               background. Keyed on the burger being rendered, not on a px value, so it cannot
               drift from the CSS breakpoint. */
            if (isSidemenuOpen && burgerButton.getClientRects().length === 0) {
                toggleSidebar()
            }
            mobileSideMenu.style.height = window.innerHeight + "px";
            var topHeaderMobileHeight = $(mobileHeader).innerHeight();// mobileSideMenuInner.style.height = `calc(100svh - ${topHeaderMobileHeight}px)`;
            mobileSideMenuInner.style.height = "".concat(window.innerHeight - topHeaderMobileHeight, "px");
            headerScroll();
            setPagePadding()
        });
        burgerButton.addEventListener("click", toggleSidebar);
        burgerButton.addEventListener("touchstart", applyMenuTexture, { once: true, passive: true });
        mobileSideMenu.addEventListener("touchstart", function (e) {
            touchstartX = e.changedTouches[0].screenX
        });
        mobileSideMenu.addEventListener("touchend", function (e) {
            touchendX = e.changedTouches[0].screenX;
            checkDirection()
        })
    }
    $(".menu_bar .navigation nav>ul>li").on("mouseenter", function () {
        if ($(this).find(".submenu").length) {
            $(this).addClass("show-submenu")
        }
    }).on("mouseleave", function () {
        if ($(this).find(".submenu").length) {
            $(this).removeClass("show-submenu")
        }
    });
    $(".js-open-mobile-submenu").on("click", function () {
        var $this = $(this);
        var $parent = $this.closest(".mobile_navigation-item");
        var $mobileCategory = $(".mobile_navigation-category");
        var category = $parent.find("h2").text();
        $mobileCategory.text(category);
        $parent.addClass("show-mobile-submenu");
        $parent.find(".mobile_navigation-submenu").css("display", "block")
    });
    $(".js-close-mobile-submenu").on("click", function () {
        $(".mobile_navigation-item").removeClass("show-mobile-submenu");
        setTimeout(function () {
            $(".mobile_navigation-submenu").css("display", "")
        }, 300)
    });
    $(".mobile_header-search-form input, .search_page-form input").on("input", function () {
        var $this = $(this);
        var $parent = $this.closest(".form-group");
        var $wrapper = $this.closest(".mobile_header-search");
        if ($this.closest(".mobile_header-search").length) {
            $wrapper = $this.closest(".mobile_header-search")
        }
        if ($this.closest(".search_page-form").length) {
            $wrapper = $this.closest(".search_page-form")
        }
        if ($this.val()) {
            $parent.addClass("filled")
        } else {
            $parent.removeClass("filled")
        }
        if ($this.val().length > 2) {
            $wrapper.addClass("searching")
        } else {
            $wrapper.removeClass("searching")
        }
    });
    $(".js-clear-field").on("click", function () {
        var $this = $(this);
        var $parent = $this.closest(".form-group");
        var $wrapper = $this.closest(".mobile_header-search");
        $parent.removeClass("filled");
        $parent.find("input").val("");
        $wrapper.removeClass("searching")
    });
    $(".js-open-header-cart").on("click", function (e) {
        e.preventDefault();
        $(".header_cart").addClass("show")
    });
    $(".js-close-header-cart").on("click", function () {
        $(".header_cart").removeClass("show")
    });
    $(document).on("click", function (e) {
        if ($(e.target).closest(".header_cart").length || $(e.target).closest(".menu_carts").length) {
            return
        }
        $(".header_cart").removeClass("show")
    });
    $(".js-cart-form-msg-show").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        var $parent = $this.closest(".bordered_btn");
        var $wrapper = $parent.closest(".cart_form-footer-msg");
        $wrapper.addClass("show")
    });/* - - - - - - - - - - - - - -       init scroll to top button       - - - - - - - - - - - - - - - */
    var scrollButton = document.querySelectorAll(".scroll_button");
    if (scrollButton.length) {
        scrollButton.forEach(function (item) {
            item.addEventListener("click", function () {
                if (window.scrollY !== 0) {
                    smoothScrollToPosition(0)
                }
            })
        })
    }/* - - - - - - - - - - - - - -       custom multy select      - - - - - - - - - - - - - - - */
    if ($(".custom_multyselect-title").length) {
        $(".custom_multyselect-title").each(function (i, elem) {
            var titleContainer = $(this);
            var optionsListContainer = $(this).parent().find(".options_list");
            var isPopoverExist = $(this).parent().find(".popover");// if (!isPopoverExist.length) {
            $(elem).mousedown(function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(".gallery_sort.select-2_wrapper").each(function () {
                    var select = $(this).find(".select-2_hidden-select");
                    select.select2("close")
                });
                $(".gallery_count.select-2_wrapper").each(function () {
                    var select = $(this).find(".select-2_hidden-select");
                    select.select2("close")
                });// titleContainer.css( 'z-index', 101 );
// $(elem).parent().toggleClass("popover-show");
                $(this).parent().toggleClass("custom_multyselect-active");
                $(".custom_multyselect-title").not(this).each(function (index, elem) {
                    $(elem).parent().removeClass("custom_multyselect-active");
                    var isPopoverExist = $(elem).parent().find(".popover");
                    if (isPopoverExist.length) {
                        $(elem).parent().removeClass("popover-show")
                    }
                })
            })
        })
    }

    function closeAllSelect(elmnt) {
        var isClickInOpenedMultySelect = $(elmnt.target).parents(".custom_multyselect-active").length;
        if (!isClickInOpenedMultySelect) {
            $(".custom_multyselect-active").each(function (index, elem) {
                elem.classList.remove("custom_multyselect-active");
                $(elem).removeClass("popover-show")
            })
        }
    }

    function resizeAllMultySelectPopovers() {
        var list = document.querySelectorAll(".custom_multyselect-title");
        list.forEach(function (elem, index) {
            var titleContainer = $(elem);
            var titleElemHeight = titleContainer.innerHeight();
            var optionsList = titleContainer.parent().find(".options_list");
            var optionsListPadding = optionsList.css("padding");
            var optionsListWidth = optionsList.innerWidth();
            var optionsListHeight = optionsList.outerHeight();
            var popoverHeight = "".concat(titleElemHeight + optionsListHeight + (parseInt(optionsListPadding) || 0), "px");
            var popoverWidth = "".concat(optionsListWidth, "px");
            var popover = titleContainer.find(".popover");
            if (popover.length) {
                popover.css("height", popoverHeight);
                popover.css("width", popoverWidth);
                popover.css("top", "-".concat(optionsListPadding))
            }
        })
    }

    document.addEventListener("click", closeAllSelect);
    document.addEventListener("keydown", function (e) {
        if (e.keyCode === 27) {
            closeAllSelect(e)
        }
    });
    window.addEventListener("resize", function () {
        if ($(".custom_multyselect-title").length) {
            setTimeout(function () {
                resizeAllMultySelectPopovers()
            })
        }
    });/* - - - - - - - - - - - - - -       init sort select-2      - - - - - - - - - - - - - - - */
    if (document.querySelector(".gallery_sort.select-2_wrapper") !== null) {
        $(".gallery_sort.select-2_wrapper").each(function () {
            var select = $(this).find(".select-2_hidden-select");
            var prefix = $(this).data("selected-prefix");
            var popover;
            select.select2({
                minimumResultsForSearch: Infinity,
                width: "100%",
                dropdownParent: $(this).find(".container-dropdown"),
                dropdownPosition: "below",
                templateSelection: formatState,
                onlyExternal: true,
                noSwiping: true
            }).on("select2:open", function (e) {
                setTimeout(function () {
                    var container = select.next();
                    var dropdownListContainer = container.next().find(".select2-container .select2-dropdown");
                    var listWidth = dropdownListContainer.innerWidth();
                    var listHeiht = dropdownListContainer.innerHeight();
                    var containerHeight = container.innerHeight();
                    var containerWidth = container.innerWidth();
                    popover = null;
                    popover = document.createElement("div");
                    popover.classList.add("popover");
                    popover.style.position = "absolute";
                    popover.style.left = "".concat(pxToRem(-16), "rem");
                    popover.style.top = "".concat(pxToRem(-16), "rem");
                    popover.style.width = "calc(".concat(listWidth > containerWidth ? listWidth : containerWidth, "px + ").concat(pxToRem(32), "rem)");
                    popover.style.height = "calc(".concat(listHeiht + containerHeight, "px + ").concat(pxToRem(16), "rem)");
                    container.append(popover)
                })
            }).on("select2:closing", function (e) {
                var container = select.next();
                container.find(".popover").remove()
            });
            $(this).find("b[role=\"presentation\"]").hide();
            $(this).find(".select2-selection__arrow").append("<div class=\"icon-arrow\"></div>");

            function formatState(state) {
                if (!state.id) {
                    return state.text
                }
                var $state = prefix ? $("<span>".concat(prefix, " ") + state.text + "</span>") : state.text;
                return $state
            }
        })
    }
    if (document.querySelector(".gallery_count.select-2_wrapper") !== null) {
        $(".gallery_count.select-2_wrapper").each(function () {
            var select = $(this).find(".select-2_hidden-select");
            var prefix = $(this).data("selected-prefix");
            var popover;
            select.select2({
                minimumResultsForSearch: Infinity,
                width: "100%",
                dropdownParent: $(this).find(".container-dropdown"),
                dropdownPosition: "below",
                templateSelection: formatState,
                onlyExternal: true,
                noSwiping: true
            }).on("select2:open", function (e) {
                setTimeout(function () {
                    var container = select.next();
                    var dropdownListContainer = container.next().find(".select2-container .select2-dropdown");
                    var listWidth = dropdownListContainer.innerWidth();
                    var listHeiht = dropdownListContainer.innerHeight();
                    var containerHeight = container.innerHeight();
                    var containerWidth = container.innerWidth();
                    popover = null;
                    popover = document.createElement("div");
                    popover.classList.add("popover");
                    popover.style.position = "absolute";
                    popover.style.left = "".concat(pxToRem(-16), "rem");
                    popover.style.top = "".concat(pxToRem(-16), "rem");
                    popover.style.width = "calc(".concat(listWidth > containerWidth ? listWidth : containerWidth, "px + ").concat(pxToRem(32), "rem)");
                    popover.style.height = "calc(".concat(listHeiht + containerHeight, "px + ").concat(pxToRem(16), "rem)");
                    container.append(popover)
                })
            }).on("select2:closing", function (e) {
                var container = select.next();
                container.find(".popover").remove()
            });
            $(this).find("b[role=\"presentation\"]").hide();
            $(this).find(".select2-selection__arrow").append("<div class=\"icon-arrow\"></div>");

            function formatState(state) {
                if (!state.id) {
                    return state.text
                }
                var $state = prefix ? $("<span>".concat(prefix, " ") + state.text + "</span>") : state.text;
                return $state
            }
        })
    }

    function recalculateSelect2PopoverSize(selectorWrapper) {
        $(selectorWrapper).each(function () {
            var select = $(this).find(".select-2_hidden-select");
            var container = select.next();
            var dropdownListContainer = container.next().find(".select2-container .select2-dropdown");
            var popover = container.find(".popover");
            var listWidth = dropdownListContainer.innerWidth();
            var listHeiht = dropdownListContainer.innerHeight();
            var containerHeight = container.innerHeight();
            var containerWidth = container.innerWidth();
            popover.css("width", "calc(".concat(listWidth > containerWidth ? listWidth : containerWidth, "px + ").concat(pxToRem(32), "rem)"));
            popover.css("height", "calc(".concat(listHeiht + containerHeight, "px + ").concat(pxToRem(16), "rem)"))
        })
    }

    window.addEventListener("resize", function () {
        if ($(".gallery_sort").length) {
            recalculateSelect2PopoverSize(".gallery_sort.select-2_wrapper")
        }
    });/* - - - - - - - - - - - - - -       init currency select-2      - - - - - - - - - - - - - - - */
    if (document.querySelector(".currency_select.select-2_wrapper") !== null) {
        $(".currency_select.select-2_wrapper").each(function () {
            var select = $(this).find(".select-2_hidden-select");
            var popover;
            select.select2({
                minimumResultsForSearch: Infinity,
                width: "100%",
                dropdownParent: $(this).find(".container-dropdown"),
                templateResult: formatState,
                templateSelection: formatStateHeader,
                onlyExternal: true,
                noSwiping: true
            }).on("select2:open", function (e) {
                setTimeout(function () {
                    var container = select.next();
                    var dropdownListContainer = container.next().find(".select2-container .select2-dropdown");
                    var flagWidth = 22 * $(window).innerWidth() / 1440;
                    var listWidth = dropdownListContainer.find(".select2-results__option:first-child span:first-child").innerWidth() + parseInt(dropdownListContainer.css("padding-left")) * 2 + flagWidth;// const listWidth = dropdownListContainer.innerWidth();
                    var listHeiht = dropdownListContainer.innerHeight();
                    var containerHeight = container.innerHeight();
                    popover = null;
                    popover = document.createElement("div");
                    popover.classList.add("popover");
                    popover.style.position = "absolute";
                    popover.style.left = 0;
                    popover.style.top = "-9px";
                    popover.style.width = "".concat(listWidth, "px");
                    popover.style.height = "".concat(listHeiht + containerHeight + containerHeight / 3, "px");
                    container.append(popover)
                })
            }).on("select2:closing", function (e) {
                var container = select.next();
                container.find(".popover").remove()
            });
            $(this).find("b[role=\"presentation\"]").hide();
            $(this).find(".select2-selection__arrow").append("<div class=\"icon-arrow\"></div>");

            function formatState(state) {
                if (!state.id) {
                    return state.text
                }
                var flag = $(state.element).data("flag");
                var $state = $("<div class=\"select-2-option-formated\">" + "<span>".concat(state.text, "</span>") + "<span><img src=\"".concat(flag, "\" alt=").concat(flag, " /></span>") + "</div>");
                return $state
            }

            function formatStateHeader(state) {
                if (!state.id) {
                    return state.text
                }
                var $state = $("\n\t\t\t\t\t<div class=\"select-2-option-formated\">\n\t\t\t\t\t\t<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t\t\t\t<path d=\"M20.3967 8.9999C20.3967 10.3254 18.2477 11.3999 15.5968 11.3999C14.68 11.3999 13.8232 11.2713 13.0946 11.0484M20.3967 8.9999V16.1998M20.3967 8.9999V5.39996M20.3967 8.9999V12.5998M10.7969 8.9999V5.39996M20.3967 16.1998C20.3967 17.5252 18.2477 18.5997 15.5968 18.5997C14.7532 18.5997 13.9604 18.4909 13.2715 18.2998M20.3967 16.1998V12.5998M10.7969 5.39996C10.7969 6.72542 12.9459 7.79992 15.5968 7.79992C18.2477 7.79992 20.3967 6.72542 20.3967 5.39996M10.7969 5.39996C10.7969 4.0745 12.9459 3 15.5968 3C18.2477 3 20.3967 4.0745 20.3967 5.39996M20.3967 5.39996V12.5998M20.3967 12.5998C20.3967 13.9253 18.2477 14.9998 15.5968 14.9998C14.7532 14.9998 13.9604 14.891 13.2715 14.6999\" stroke=\"#F5F5F5\" stroke-width=\"1.1\"/>\n\t\t\t\t\t\t\t<path d=\"M3.59961 18.5998V11.4M3.59961 18.5998C3.59961 19.9253 5.74861 20.9998 8.39953 20.9998C11.0505 20.9998 13.1995 19.9253 13.1995 18.5998M3.59961 18.5998V14.9999M3.59961 11.4C3.59961 12.7254 5.74861 13.7999 8.39953 13.7999C11.0505 13.7999 13.1995 12.7254 13.1995 11.4M3.59961 11.4C3.59961 10.0745 5.74861 9 8.39953 9C11.0505 9 13.1995 10.0745 13.1995 11.4M3.59961 11.4V14.9999M13.1995 11.4V18.5998M13.1995 11.4V14.9999M13.1995 18.5998V14.9999M13.1995 14.9999C13.1995 16.3254 11.0505 17.3999 8.39953 17.3999C5.74861 17.3999 3.59961 16.3254 3.59961 14.9999\" stroke=\"#F5F5F5\" stroke-width=\"1.1\"/>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t<span>".concat(state.text, "</span>\n\t\t\t\t\t</div>\n\t\t\t\t"));
                return $state
            }
        })
    }// window.addEventListener( ( 'resize' ), () => recalculateSelect2PopoverSize( '.currency_select.select-2_wrapper' ) );
    /* - - - - - - - - - - - - - -       init filters mobile menu      - - - - - - - - - - - - - - - */
    var sidebarOpen = false;
    var menuTrigger = $("#filter-menu-trigger");
    var menuOverlay = $("#filters-menu");
    var menuBodyOverlay = $(".filters_menu-body");
    var closeTrigger = $("#filters-menu-close");
    var backTrigger = $("#filters-menu-back");
    var body = $(document.body);
    menuOverlay.addClass("transition");
    menuOverlay.css("height", "calc(" + window.innerHeight + "px" + ")");
    menuBodyOverlay.css("height", "calc(" + window.innerHeight + "px" + " - " + pxToRem(35) + "rem" + ")");
    var closeMenu = function closeMenu() {
        body.removeClass("overflow-hidden");
        menuTrigger.removeClass("is-open");
        menuOverlay.removeClass("is-open");
        sidebarOpen = !sidebarOpen
    };
    menuTrigger.on("click", function () {
        body.addClass("overflow-hidden");
        $(this).addClass("is-open");
        menuOverlay.addClass("is-open");
        sidebarOpen = true
    });
    closeTrigger.on("click", closeMenu);
    backTrigger.on("click", closeMenu);
    $(window).on("resize", function () {
        menuOverlay.css("height", "calc(" + window.innerHeight + "px" + ")");
        menuBodyOverlay.css("height", "calc(" + window.innerHeight + "px" + " - " + pxToRem(35) + "rem" + ")")
    });
    document.addEventListener("keydown", function (e) {
        if (e.keyCode === 27) {
            closeMenu()
        }
    });/* - - - - - - - - - - - - - -       filter acordion      - - - - - - - - - - - - - - - */ // const acc = document.getElementsByClassName("accordion");
    function accordion($this) {
        var $accordion = $this;
        var $accordionBox = $accordion.closest(".accordion_wrapper-row");
        var $accordionContent = $accordionBox.find(".panel");
        var $accordionWrapper = $accordion.closest(".accordion_wrapper");
        var accordionView = $accordionWrapper.find(".accordion_wrapper-row .accordion.active").length + 1;
        if (!$accordion.hasClass("active")) {
            if (accordionView > 2) {
                var $firstAccordion = $accordionWrapper.find(".accordion_wrapper-row").has(".accordion.active").first();
                $firstAccordion.find(".accordion").removeClass("active");
                $firstAccordion.find(".panel").slideUp(300)
            }
            $accordion.addClass("active");
            $accordionContent.slideDown(300)
        } else {
            $accordion.removeClass("active");
            $accordionContent.slideUp(300)
        }
    }

    if ($(".accordion").length) {
        var accordionView = 0;
        $(".accordion").each(function () {
            var $accordion = $(this);
            var $accordionBox = $accordion.closest(".accordion_wrapper-row");
            var $accordionContent = $accordionBox.find(".panel");
            if ($accordion.hasClass("active")) {
                accordionView += 1;
                if (accordionView <= 2) {
                    $accordionContent.slideDown(300)
                } else {
                    $accordion.removeClass("active");
                    $accordionContent.slideUp(300)
                }
            } else {
                $accordionContent.slideUp(300)
            }
        });
        $(".accordion").on("click", function () {
            accordion($(this))
        })
    }/* - - - - - - - - - - - - - -       init collections list sliders      - - - - - - - - - - - - - - - */
    var collectionsListWrapper = $(".collections_page .gallery");
    var collectionsList = $(".collections_page .gallery_list");
    var mm;
    if (collectionsListWrapper.length && collectionsList.length) {
        setTimeout(function () {
            initCollectionsList()
        }, 10)
    }

    function initCollectionsList() {
        var isItMobile = window.innerWidth <= 1024;
        var header;
        var breadcrumbs;
        var listHeight;
        if (window.innerWidth > 1024) {
            header = $(".header_nav");
            breadcrumbs = $(".breadcrumbs");
            listHeight = window.innerHeight - header.innerHeight() - breadcrumbs.outerHeight() + "px"
        } else {
            listHeight = "auto"
        }
        collectionsListWrapper.css("height", listHeight);
        var items = collectionsList.find(".gallery_list-item");
        items.each(function (i, item) {
            var card = $(item).find(".gallery_card");
            var cardBody = $(item).find(".gallery_card-body");
            var cardBodyMargin = cardBody.css("margin-bottom");
            var cardFooter = $(item).find(".gallery_card-footer");
            var paddingTop = collectionsListWrapper.css("padding-top");
            var paddingBottom = collectionsListWrapper.css("padding-bottom");
            var height = collectionsListWrapper.innerHeight() - parseFloat(paddingTop) - parseFloat(paddingBottom) - cardFooter.innerHeight() - parseFloat(cardBodyMargin) + "px";
            if (cardBody.width() < cardBody.height()) {
                item.classList.add("vertical_item");
                if (window.innerWidth > 1024) {
                    cardBody.css("max-height", height)
                } else {
                    cardBody.css("max-height", "auto")
                }
            } else {
                item.classList.add("horizontal_item")
            }
        });
        collectionsList.addClass("gallery_grid");
        mm = gsap.matchMedia();// add a media query. When it matches, the associated function will run
        mm.add("(min-width: 1025px)", function () {
            /* Gallery pin + heading/breadcrumb retract share ONE ScrollTrigger. Separate triggers with
               start:"top top" end:"bottom bottom" on an 80px element resolve to a ~0 range. Snap by the
               real card offsets (448/616px pitch), not 1/(items-1) — a uniform step fought Lenis. */
            if (!$(".gallery_list").length) {
                return
            }
            var galleryList = document.querySelector(".gallery_list");

            function galleryWidth() {
                return galleryList.offsetWidth
            }

            /* Warm this gallery's off-screen cards: the shared lazy loader's rootMargin band
               (1600px as of 28 Aug) is vertical only — and this is the site's one horizontal
               gallery, so cards off-screen to the RIGHT never preload and all decode during the
               first scroll. Idle-scheduled, with a timeout so it still beats a user who scrolls
               immediately. */
            function warmGalleryImages() {
                var lazy = galleryList.querySelectorAll("img[data-src], img[data-srcset]");
                Array.prototype.forEach.call(lazy, function (img) {
                    var pic = img.parentNode;
                    if (pic && pic.tagName === "PICTURE") {
                        var srcs = pic.querySelectorAll("source[data-srcset]");
                        for (var j = 0; j < srcs.length; j++) {
                            srcs[j].setAttribute("srcset", srcs[j].getAttribute("data-srcset"));
                            srcs[j].removeAttribute("data-srcset")
                        }
                    }
                    /* low priority: these are off-screen, so they must queue behind the
                       visible cards (one of which is this page's LCP element) rather than
                       compete with them for bandwidth. Ignored by browsers that lack it. */
                    img.setAttribute("fetchpriority", "low");
                    if (img.getAttribute("data-src")) {
                        img.removeAttribute("src");
                        img.setAttribute("src", img.getAttribute("data-src"));
                        img.removeAttribute("data-src")
                    }
                    if (img.getAttribute("data-srcset")) {
                        img.setAttribute("srcset", img.getAttribute("data-srcset"));
                        img.removeAttribute("data-srcset")
                    }
                })
            }

            /* Short timeout: the visible cards are already queued by the shared loader above
               (it runs at parse time, this runs at DOMContentLoaded+10ms), so warming here is
               always behind them — but it still has to beat a visitor who scrolls immediately. */
            if (window.requestIdleCallback) {
                requestIdleCallback(warmGalleryImages, {timeout: 300})
            } else {
                setTimeout(warmGalleryImages, 200)
            }

            /* Snap to the next card edge IN THE DIRECTION OF TRAVEL. "Nearest edge" undid every flick:
               Lenis's glide often rests short of halfway, so nearest was the edge behind. Only a rest
               within 15% of the edge just passed settles back to it. Offsets are measured live. */
            function snapToCards(value, direction) {
                var cards = galleryList.querySelectorAll(".gallery_list-item");
                var travel = galleryWidth() - window.innerWidth;
                if (travel <= 0 || !cards.length) {
                    return value
                }
                var first = cards[0].offsetLeft;
                var below = 0;
                var above = 1;
                Array.prototype.forEach.call(cards, function (card) {
                    var p = (card.offsetLeft - first) / travel;
                    p = p < 0 ? 0 : (p > 1 ? 1 : p);
                    if (p <= value && p > below) {
                        below = p
                    }
                    if (p >= value && p < above) {
                        above = p
                    }
                });
                if (above - below < 1e-6) {
                    return below
                }
                var x = (value - below) / (above - below);
                var BACK_ZONE = 0.15;
                if (direction < 0) {
                    return (1 - x) <= BACK_ZONE ? above : below
                }
                return x <= BACK_ZONE ? below : above
            }

            /* Lenis must animate the settle wherever Lenis owns scrolling: ScrollTrigger's own snap
               writes the scroll position directly and Lenis ignores external writes mid-animation, so
               the two fight. Start from ScrollTrigger's "scrollEnd" (true rest), not a pause inside
               Lenis's tail. Safari has no Lenis, so the built-in snap stays there. expo.out matches
               Lenis's easing, so the settle reads as a continuation rather than a second jump. */
            var lenisGoverns = !isSafariBrowser;
            var settleEase = function settleEase(t) {
                return t === 1 ? 1 : 1 - Math.pow(2, -10 * t)
            };

            /* Heading and breadcrumb retract over the first ~320px of the pinned scroll,
               expressed as a fraction of the timeline so it stays genuinely scroll-linked. */
            var headDuration = galleryWidth() > 0 ? Math.min(0.5, 320 / galleryWidth()) : 0.06;
            var stConfig = {
                trigger: ".wrapper",
                pin: true,
                /* Safari gets scrub:true, Chrome scrub:1. scrub:1 is a one-second catch-up that reads as
                   smooth only because Lenis pre-smooths the input; on Safari (no Lenis, deliberately — it
                   caused the P0 scroll freeze) the raw OS momentum makes the same catch-up look like drift. */
                scrub: lenisGoverns ? 1 : true,
                end: function end() {
                    return "+=" + galleryWidth()
                },
                invalidateOnRefresh: true,
                anticipatePin: 1
            };
            /* Safari gets NO GSAP snap — native CSS scroll-snap below replaces it. A snap tween writes
               the scroll position while WebKit's inertia writes it too, and WebKit's cannot be cancelled
               from JS; those two writers are the judder. One writer per engine. */
            var tl = gsap.timeline({scrollTrigger: stConfig});
            tl.to(".gallery_list", {
                xPercent: -100,
                x: function x() {
                    return window.innerWidth
                },
                ease: "none",
                duration: 1
            }, 0);
            if ($(".title_container").length) {
                tl.to(".title_container", {
                    xPercent: -1,
                    y: function y() {
                        return -document.querySelector(".title_container").offsetHeight
                    },
                    ease: "none",
                    duration: headDuration
                }, 0)
            }
            if ($(".breadcrumbs_list").length) {
                tl.to(".breadcrumbs_list-item", {
                    xPercent: -1,
                    y: function y() {
                        return -document.querySelector(".breadcrumbs_list").offsetHeight
                    },
                    ease: "none",
                    duration: headDuration
                }, 0)
            }
            var settleTween = null;
            var onRest = null;
            if (lenisGoverns) {
                onRest = function onRest() {
                    var st = tl.scrollTrigger;
                    if (!st || !st.isActive) {
                        return
                    }
                    var p = st.progress;
                    if (p < 0.0001 || p > 0.9999) {
                        return
                    }
                    var targetY = st.start + snapToCards(p, st.direction) * (st.end - st.start);
                    var dist = Math.abs(targetY - window.scrollY);
                    if (dist < 2) {
                        /* already on an edge (the settle's own completion re-fires scrollEnd
                           and lands here — this is the loop terminator) */
                        return
                    }
                    var dur = Math.min(0.8, Math.max(0.35, dist / 900));
                    if (window.lenis) {
                        /* single writer: Lenis animates its own settle, and a wheel input
                           mid-settle simply retargets it — nothing to kill, nothing fights */
                        window.lenis.scrollTo(targetY, {duration: dur, easing: settleEase})
                    } else {
                        /* pre-init window only: Lenis arrives via requestIdleCallback (up to
                           ~3s after load), native scroll until then. Same settle, gsap-
                           tweened; any real user input kills it. */
                        if (settleTween) {
                            settleTween.kill()
                        }
                        var pos = {y: window.scrollY};
                        var killSettle = function killSettle() {
                            if (settleTween) {
                                settleTween.kill();
                                settleTween = null
                            }
                            window.removeEventListener("wheel", killSettle);
                            window.removeEventListener("touchstart", killSettle)
                        };
                        settleTween = gsap.to(pos, {
                            y: targetY,
                            duration: dur,
                            ease: "expo.out",
                            onUpdate: function onUpdate() {
                                window.scrollTo(0, pos.y)
                            },
                            onComplete: killSettle
                        });
                        window.addEventListener("wheel", killSettle, {passive: true});
                        window.addEventListener("touchstart", killSettle, {passive: true})
                    }
                };
                ScrollTrigger.addEventListener("scrollEnd", onRest)
            }

            /* Retarget Lenis MID-GLIDE, ~170ms after the last wheel event, instead of waiting for
               scrollEnd: Lenis's tail emits sub-pixel events ~0.3s past visible rest, so a scrollEnd
               settle read as stop -> beat -> second movement. Endpoints unchanged, only timing. 170ms
               exceeds any gap in continuous input, so it cannot fire mid-gesture. The scrollEnd settle
               stays as the terminator and as the keyboard/scrollbar fallback. */
            /* SAFARI: zero-size snap targets parked at each card-edge offset, plus scroll-snap-type:
               y proximity, so WebKit snaps with its own physics and GSAP only READS the scroll.
               Rebuilt on every ScrollTrigger refresh; each target verifies its resolved position after
               insertion, so it does not matter whether <body> is static or relative. `proximity`, not
               `mandatory`, so the rest of the page still scrolls normally. */
            var snapEls = [];
            var onSTRefresh = null;
            var snapSig = null;

            function clearSafariSnap() {
                for (var i = 0; i < snapEls.length; i++) {
                    if (snapEls[i].parentNode) {
                        snapEls[i].parentNode.removeChild(snapEls[i])
                    }
                }
                snapEls = [];
                snapSig = null;
                document.documentElement.classList.remove("collections-native-snap")
            }

            function buildSafariSnap() {
                var st = tl.scrollTrigger;
                if (!st) {
                    clearSafariSnap();
                    return
                }
                var cards = galleryList.querySelectorAll(".gallery_list-item");
                var travel = galleryWidth() - window.innerWidth;
                var span = st.end - st.start;
                if (travel <= 0 || !cards.length || span <= 0) {
                    clearSafariSnap();
                    return
                }
                var first = cards[0].offsetLeft;
                /* ScrollTrigger refreshes on every <img> load, so rebuild only when the geometry moved. */
                var sig = Math.round(st.start) + ":" + Math.round(st.end) + ":" + Math.round(travel) + ":" +
                    Array.prototype.map.call(cards, function (c) { return c.offsetLeft }).join(",");
                if (sig === snapSig && snapEls.length) {
                    return
                }
                clearSafariSnap();
                snapSig = sig;
                Array.prototype.forEach.call(cards, function (card) {
                    var p = (card.offsetLeft - first) / travel;
                    p = p < 0 ? 0 : (p > 1 ? 1 : p);
                    /* No target at the pin's entry or exit (same guard as the Chrome settle): two cards clamp
                       to p=1, and `proximity` would make that boundary sticky on the way to the footer. */
                    if (p < 0.0001 || p > 0.9999) {
                        return
                    }
                    var y = st.start + p * span;
                    var el = document.createElement("div");
                    el.className = "collections-snap-point";
                    el.style.cssText = "position:absolute;left:0;width:1px;height:1px;opacity:0;pointer-events:none;scroll-snap-align:start;top:" + Math.round(y) + "px";
                    document.body.appendChild(el);
                    /* self-correct against whatever containing block <body> establishes */
                    var actual = el.getBoundingClientRect().top + window.scrollY;
                    if (Math.abs(actual - y) > 0.5) {
                        el.style.top = Math.round(y + (y - actual)) + "px"
                    }
                    snapEls.push(el)
                });
                document.documentElement.classList.add("collections-native-snap")
            }

            if (!lenisGoverns) {
                buildSafariSnap();
                onSTRefresh = function onSTRefresh() {
                    buildSafariSnap()
                };
                ScrollTrigger.addEventListener("refresh", onSTRefresh)
            }
            var settleTimer = null;
            var onWheelIdle = null;
            if (lenisGoverns) {
                var earlyRetarget = function earlyRetarget() {
                    settleTimer = null;
                    var st = tl.scrollTrigger;
                    if (!st || !st.isActive || !window.lenis || !window.lenis.isScrolling) {
                        return
                    }
                    var span = st.end - st.start;
                    var T = window.lenis.targetScroll;
                    var pT = (T - st.start) / span;
                    if (pT < 0.0001 || pT > 0.9999) {
                        /* the glide is leaving the pin — let it exit naturally */
                        return
                    }
                    var direction = T >= window.lenis.animatedScroll ? 1 : -1;
                    var targetY = st.start + snapToCards(pT, direction) * span;
                    if (Math.abs(targetY - T) < 2) {
                        return
                    }
                    var dist = Math.abs(targetY - window.scrollY);
                    window.lenis.scrollTo(targetY, {
                        duration: Math.min(0.8, Math.max(0.35, dist / 900)),
                        easing: settleEase
                    })
                };
                onWheelIdle = function onWheelIdle() {
                    if (settleTimer) {
                        clearTimeout(settleTimer)
                    }
                    settleTimer = setTimeout(earlyRetarget, 170)
                };
                window.addEventListener("wheel", onWheelIdle, {passive: true})
            }
            return function cleanup() {
                if (onSTRefresh) {
                    ScrollTrigger.removeEventListener("refresh", onSTRefresh)
                }
                clearSafariSnap();
                document.documentElement.classList.remove("collections-native-snap");
                if (onRest) {
                    ScrollTrigger.removeEventListener("scrollEnd", onRest)
                }
                if (onWheelIdle) {
                    window.removeEventListener("wheel", onWheelIdle);
                    if (settleTimer) {
                        clearTimeout(settleTimer);
                        settleTimer = null
                    }
                }
                if (settleTween) {
                    settleTween.kill();
                    settleTween = null
                }
            }
        });// mm.revert();
    }

    window.addEventListener("resize", function () {
        if (collectionsListWrapper.length && collectionsList.length) {
            if (mm) {
                mm.revert()
            }
            initCollectionsList()
        }
    });/* - - - - - - - - - - - - - -       init collection sliders      - - - - - - - - - - - - - - - */
    var previewSlider = $(".preview_swiper");
    var thumbnailsSlider = $(".thumbs_swiper");
    var swiper;
    var swiper2;
    var count = $(".collection_gallery-count");
    var title = $(".collection_gallery-title");
    var tag = $(".category-tag");
    var buttonLink = $(".shopnow_button-link");
    if (previewSlider && thumbnailsSlider) {
        swiper = new Swiper(".thumbs_swiper", {
            spaceBetween: 8,
            slidesPerView: "auto",
            freeMode: true,
            watchSlidesProgress: true,
            scrollbar: {el: ".swiper-scrollbar", hide: true},
            direction: "vertical",
            mousewheelControl: true,// slidesPerView: 1
// slidesPerView: 'auto'
// freeMode: true
            mousewheel: true
        });
        swiper2 = new Swiper(".preview_swiper", {
            spaceBetween: 32,
            slidesPerView: 1.3,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            navigation: {nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev"},
            thumbs: {swiper: swiper},
            breakpoints: {
                575: {spaceBetween: 32, slidesPerView: 2.3, slidesOffsetBefore: 16, slidesOffsetAfter: 16},
                1025: {spaceBetween: 4, effect: "fade", slidesPerView: 1, slidesOffsetBefore: 0, slidesOffsetAfter: 0}
            },
            on: {
                init: function init(e) {
                    var indexCurrentSlide = this.realIndex;
                    var currentSlide = this.slides[indexCurrentSlide];
                    var tagV = $(currentSlide).data("product-tag");
                    count.html("".concat(indexCurrentSlide + 1, " &mdash; ").concat(this.slides.length));
                    title.html($(currentSlide).data("product-name"));
                    if (tagV) {
                        tag.html(tagV);
                        tag.css("display", "flex")
                    } else {
                        tag.html("");
                        tag.css("display", "none")
                    }
                    buttonLink.attr("href", $(currentSlide).data("product-url"))
                }, slideChange: function slideChange(e) {
                    var indexCurrentSlide = this.realIndex;
                    var currentSlide = this.slides[indexCurrentSlide];
                    var tagV = $(currentSlide).data("product-tag");
                    count.html("".concat(indexCurrentSlide + 1, " &mdash; ").concat(this.slides.length));
                    title.html($(currentSlide).data("product-name"));
                    if (tagV) {
                        tag.html(tagV);
                        tag.css("display", "flex")
                    } else {
                        tag.html("");
                        tag.css("display", "none")
                    }
                    buttonLink.attr("href", $(currentSlide).data("product-url"))
                }
            }
        })
    }
    var collectionGallery = document.querySelector(".collection_gallery");
    if (collectionGallery) {
        var collectionGallerySlider = collectionGallery.querySelector(".collection_gallery-slider");
        if (collectionGallerySlider && window.innerWidth > 1024) {
            collectionGallerySlider.style.minHeight = "";
            collectionGallerySlider.style.minHeight = "".concat(collectionGallery.offsetHeight, "px");
            $(window).on("resize", function () {
                collectionGallerySlider.style.minHeight = "";
                collectionGallerySlider.style.minHeight = "".concat(collectionGallery.offsetHeight, "px")
            })
        }
    }/* - - - - - - - - - - - - - -       init image zoom      - - - - - - - - - - - - - - - */
    if ($(".img-zoom-container").length) {
        imageZoom(".img-zoom-container")
    }
    $(document).on("mouseenter", ".collection_gallery", function () {
        imageZoom(".img-zoom-container")
    });
    var resizeTimeout;
    $(window).on("resize", function () {
        if ($(".img-zoom-container").length) {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                imageZoom(".img-zoom-container")
            }, 600)
        }
    });/* - - - - - - - - - - - - - -       init product form       - - - - - - - - - - - - - - - */
    var productForm = document.querySelector(".product_form");
    var BLACK_FRAMED = "black";
    var WHITE_FRAMED = "white";
    var PRINT_ONLY = "print_only";
    var productPreviewImg;
    var productPreviewFramed;
    var productImgWidth;
    var productImgHeight;
    if (productForm) {
        productPreviewImg = document.querySelector("#product_preview");
        productPreviewFramed = document.querySelector(".product_info-box-framing");
        productImgWidth = productPreviewImg.querySelector(".product_info-cover").clientWidth;
        productImgHeight = productPreviewImg.querySelector(".product_info-cover").clientHeight;//changePrintFramed();
        $("input[name=\"framing\"]").each(function (index, elem) {//elem.addEventListener( 'change', changePrintFramed );
        });
        var sizeRadio = $("input[name=\"size_type\"]");
        sizeRadio.each(function () {
            $(this).on("change", convertSize)
        });
        var successMsg = $(".form_message.error_message");
        var errorMsg = $(".form_message.success_message");
        var closeBtnSuccess = successMsg.children(".close_message");
        var closeBtnError = errorMsg.children(".close_message");
        closeBtnSuccess.on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            successMsg.addClass("hidden_msg")
        });
        closeBtnError.on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            errorMsg.addClass("hidden_msg")
        })
    }

    function changePrintFramed() {
        var framedRadioButton = document.querySelector("input[name=\"framing\"]:checked");
        var framedValue = $(framedRadioButton).attr("value");
        var isHorizontal = productImgWidth / productImgHeight >= 1;
        var frameOrientationClass = isHorizontal ? "framed_box" : "framed_box_vertical";
        var paddingLeft = isHorizontal ? productImgWidth / 100 * 6 : productImgWidth / 100 * 11;
        var paddingBottom = productImgHeight / 100 * 7;
        var img = document.createElement("img");
        img.src = "".concat(window.location.origin, "/img/product/") + "".concat(framedValue, "-").concat(isHorizontal ? "horizontal" : "vertical", "-").concat(window.innerWidth > 1024 ? "desktop" : "mobile", ".png");
        img.alt = "print framed";
        img.classList = "";
        $(productPreviewFramed).empty();
        productPreviewFramed.appendChild(img);
        if (framedValue && framedValue !== PRINT_ONLY) {
            productPreviewImg.classList.add(frameOrientationClass);
            productPreviewImg.style.paddingLeft = paddingLeft + "px";
            productPreviewImg.style.paddingBottom = paddingBottom + "px"
        } else {
            productPreviewImg.classList.remove(frameOrientationClass);
            productPreviewImg.style.paddingLeft = "0";
            productPreviewImg.style.paddingBottom = "0"
        }
    }

    window.addEventListener("resize", function () {
        if (productForm) {
            productPreviewImg = document.querySelector("#product_preview");
            productImgWidth = productPreviewImg.querySelector(".product_info-cover").clientWidth;
            productImgHeight = productPreviewImg.querySelector(".product_info-cover").clientHeight;//changePrintFramed();
        }
    });

    function convertSize() {
        var _$$parents$find;
        var activeSizeType = document.querySelector("input[name=\"size_type\"]:checked");
        var sizeTypeValue = activeSizeType.getAttribute("value");// const sizeRadio = $('input[name="size"]');
        var sizeRadio = $("input[data-name=\"options[size]\"]");
        var currentOptionText = $(".product_form-row.size .product_form-header_title");
        var checkedRadioLabel = (_$$parents$find = $(sizeRadio).parents(".product_form-dropdown-list-item.active").find("label")) === null || _$$parents$find === void 0 ? void 0 : _$$parents$find[0];
        sizeRadio.each(function (i, elem) {
            var sizeValue = $(this).attr("value");
            var title = activeSizeType.dataset.title ? activeSizeType.dataset.title : false;
            var multiplier = activeSizeType.dataset.multiplier ? parseFloat(activeSizeType.dataset.multiplier) : false;
            var sizeValues = sizeValue.split("-").map(function (el) {
                if (hasNumber(el.trim())) {
                    var elNumbers = el.trim().split("x").map(function (item) {
                        var value = parseFloat(item.trim());
                        if (multiplier) {
                            value = (value * multiplier).toFixed(2)
                        }
                        return value
                    });
                    return elNumbers.join(" x ")
                }
                return el.trim()
            });// const sizeValues = sizeValue.split('x').map((item) => {
            var newValue = sizeValues.join(" - ") + (title ? " ".concat(title) : "");
            var label = elem.nextElementSibling;
            label.innerHTML = newValue;
            if (currentOptionText && checkedRadioLabel) {
                currentOptionText === null || currentOptionText === void 0 || currentOptionText.text(checkedRadioLabel.textContent)
            }
        })
    }

    var hasNumber = function hasNumber(str) {
        return /[0-9]/.test(str)
    };/* - - - - - - - - - - - - - -       init anchors tabs       - - - - - - - - - - - - - - - */
    var productDetailDesktopPreview = $(".product_info-preview .product_info-preview-wrapp");
    var productDetailDesktopScroll = $(".product_info-preview .product_info-scroll");
    var scrollStartCoord;
    var productDetailDesktopPreviewHeight = 0;

    function refreshPreviewPositionMetrics() {
        if (!productDetailDesktopPreview.length || !productDetailDesktopScroll.length || window.innerWidth <= 1024) {
            return
        }
        scrollStartCoord = getAbsoluteElementTop(productDetailDesktopScroll[0]);
        productDetailDesktopPreviewHeight = productDetailDesktopPreview[0].offsetHeight
    }



    if (productDetailDesktopPreview.length) {
        refreshPreviewPositionMetrics();
        changePreviewPosition();
        registerScrollTask(changePreviewPosition, false);
        registerResizeTask(refreshPreviewPositionMetrics, false);
        registerResizeTask(changePreviewPosition, false);
        window.addEventListener("resize", function () {
            if (window.innerWidth <= 1024) {
                productDetailDesktopPreview.removeClass("fixed_box");
                productDetailDesktopPreview.removeClass("absolute_box");
                return
            }
            refreshPreviewPositionMetrics();
            changePreviewPosition()
        })
    }

    function changePreviewPosition() {
        refreshPreviewPositionMetrics()
        if (window.innerWidth <= 1024) {
            productDetailDesktopPreview.removeClass("fixed_box");
            productDetailDesktopPreview.removeClass("absolute_box");
            return
        }
        if (!productDetailDesktopScroll.length) return;
        if (window.scrollY < scrollStartCoord - productDetailDesktopPreviewHeight - 200) {
            productDetailDesktopPreview.addClass("fixed_box");
            productDetailDesktopPreview.removeClass("absolute_box");
            if (window.scrollY > 35) {
                productDetailDesktopPreview.addClass("scrolled")
            } else {
                productDetailDesktopPreview.removeClass("scrolled")
            }
        } else {
            productDetailDesktopPreview.addClass("absolute_box");
            productDetailDesktopPreview.removeClass("fixed_box");
            productDetailDesktopPreview.removeClass("scrolled")
        }
    }/* - - - - - - - - - - - - - -       init anchors tabs       - - - - - - - - - - - - - - - */
    var initDesktopAnchorPosition;
    var initMobileAnchorPosition;
    var anchorsTabsHeight;
    var anchorsOverlayHeight;
    var headerNavHeight;
    var isTabsMode;
    var scrollAreaSelector;
    var scrollAreaContainer;
    var scrollAreaEndCoord;
    var initAnchorPosition;
    var currentScrollPos;
    var anchorsWrapper = $(".anchor_wrapper");
    if (anchorsWrapper.length) {
        setTimeout(function () {
            initAnchorTabs()
        }, 200)
    }

    function getElementDocumentTop(el) {
        var top = 0;
        while (el) {
            top += el.offsetTop;
            el = el.offsetParent
        }
        return top
    }

    function initAnchorTabs() {
        var anchorsSliderWrapper = document.querySelector(".anchor_slider");
        var anchorsItemsWrapper = document.querySelector(".anchors");
        if (!anchorsSliderWrapper || !anchorsItemsWrapper) {
            return
        }
        isTabsMode = anchorsWrapper.data("tabs-mode");
        scrollAreaSelector = anchorsWrapper.data("scroll-area");
        scrollAreaContainer = document.querySelector(scrollAreaSelector);
        scrollAreaEndCoord = scrollAreaContainer.getBoundingClientRect().bottom + document.documentElement.scrollTop;
        if (!isTabsMode) {
            initAnchorsSliderFromTextContent(anchorsItemsWrapper)
        }
        var slider = new Swiper(".anchor_slider", {
            slidesPerView: "auto",
            mousewheel: true,
            breakpoints: {1025: {spaceBetween: 0, slidesPerView: "auto"}}
        });
        var links = anchorsSliderWrapper.querySelectorAll(".anchor");
        /* The .anchor.active CSS shipped but the JS that sets it was commented out — chips never
           highlighted. Non-tabs pages only; the awards year-tabs own their active state. */
        var spyPairs = [];
        /* A chip click highlights immediately, then the smooth scroll fires the spy from every
           intermediate position and steals it. Lock the spy while a click-scroll is in flight;
           release on arrival (±3px) or after 2s. */
        var spyLockPos = null;
        var spyLockTime = 0;
        function setActiveChip(chipEl, slideIndex) {
            var current = anchorsSliderWrapper.querySelector(".anchor.active");
            if (current === chipEl) return;
            if (current) current.classList.remove("active");
            chipEl.classList.add("active");
            if (typeof slideIndex === "number" && slider && slider.slideTo) slider.slideTo(slideIndex)
        }
        Array.from(links).forEach(function (linkItem, index) {
            var linkElem = linkItem.querySelector("a");
            var link = linkElem === null || linkElem === void 0 ? void 0 : linkElem.dataset.title;
            var title = document.querySelector("h3[data-title=\"" + link + "\"]");
            if (isTabsMode) {
                return linkElem === null || linkElem === void 0 ? void 0 : linkElem.addEventListener("click", function (e) {
                    e.preventDefault();
                    var targetElem = document.querySelector(".awards_section-header");
                    if (targetElem) {
                        var rect = targetElem.getBoundingClientRect();
                        var scrollTop = window.scrollY + rect.top - headerNavHeight;
                        smoothScrollToPosition(scrollTop)
                    }
                })
            }
            if (!title) {
                return
            }
            spyPairs.push({chip: linkItem, title: title, idx: index});
            linkElem === null || linkElem === void 0 || linkElem.addEventListener("click", function (e) {
                e.preventDefault();
                setActiveChip(linkItem, index);
                var absoluteTop = getElementDocumentTop(title);
                /* S26: land the heading just BELOW the pinned bar's full box (top offset +
                   its own padded height), not under it — the old offset (slider height +
                   header) left the target covered by the pinned bar. */
                var target = Math.max(0, Math.round(absoluteTop - anchorsOverlayHeight));
                spyLockPos = target;
                spyLockTime = Date.now();
                smoothScrollToPosition(target)
            });
        });
        setTabsHeight();
        makeAnchorsFixed();
        if (spyPairs.length) {
            /* S08 scrollspy: the section whose heading has passed the pinned bar line is the
               active one; keep its chip visible in the swiper. Uses the same offset model as
               the click targets so a click always activates the section it scrolls to. */
            var spyScroll = function spyScroll() {
                if (spyLockPos !== null) {
                    if (Math.abs(window.pageYOffset - spyLockPos) < 3 || Date.now() - spyLockTime > 2000) {
                        spyLockPos = null
                    } else {
                        return
                    }
                }
                var pos = window.pageYOffset + anchorsOverlayHeight + 1;
                var activePair = null;
                for (var i = 0; i < spyPairs.length; i++) {
                    if (getElementDocumentTop(spyPairs[i].title) <= pos) activePair = spyPairs[i]
                }
                if (activePair) setActiveChip(activePair.chip, activePair.idx)
            };
            registerScrollTask(spyScroll, false);
            spyScroll()
        }
    }

    function initAnchorsSliderFromTextContent(anchorsItemsWrapper) {
        var h3 = scrollAreaContainer.querySelectorAll("h3");
        var tabsFromH3 = "";
        var seen = new Set;
        h3 === null || h3 === void 0 || h3.forEach(function (elem, i) {
            var text = elem.textContent.trim();
            if (seen.has(text)) return;
            seen.add(text);
            elem.dataset.title = "title-" + i;
            tabsFromH3 += "\n\t\t\t\t<div class=\"swiper-slide anchor\">\n\t\t\t\t\t<a href=\"#\" data-title=\"title-".concat(i, "\">").concat(elem.innerHTML, "</a>\n\t\t\t\t</div>\n\t\t\t")
        });
        anchorsItemsWrapper.innerHTML = tabsFromH3
    }

    function setTabsHeight() {
        headerNavHeight = window.innerWidth > 1024 ? $(".header_nav").innerHeight() : $(".header_nav-mobile").innerHeight();
        var anchorsWrapper = document.querySelector(".anchor_wrapper");
        var anchorsContainer = document.querySelector(".anchor_slider");
        /* Pin threshold = header + the .fixed padding-top, because that is where the chips render
           once pinned; any other value jumps. The old one used the DESKTOP-only .header_nav
           (display:none on phones), so the bar pinned ~100px late and covered the list. */
        var rootFont = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
        var fixedPadTop = (window.innerWidth <= 1024 ? 2.5 : 1.25) * rootFont;
        anchorsTabsHeight = headerNavHeight + fixedPadTop;
        anchorsOverlayHeight = anchorsTabsHeight + $(anchorsContainer).innerHeight() + 1.5 * rootFont;
        if (window.innerWidth > 1024) {
            initDesktopAnchorPosition = anchorsWrapper.getBoundingClientRect().top + document.documentElement.scrollTop
        } else if (window.innerWidth <= 1024) {
            initMobileAnchorPosition = anchorsWrapper.getBoundingClientRect().top + document.documentElement.scrollTop
        }
        if (scrollAreaContainer) {
            scrollAreaEndCoord = getAbsoluteElementTop(scrollAreaContainer) + scrollAreaContainer.offsetHeight
        }
    }

    function updateAnchorsScrollData() {
        currentScrollPos = window.pageYOffset;
        initAnchorPosition = window.innerWidth <= 1024 ? initMobileAnchorPosition : initDesktopAnchorPosition
    }

    function setFixedAnchorWrapper(anchorsContainer) {// if (currentScrollPos >= initAnchorPosition - anchorsTabsHeight) {
        if (currentScrollPos >= initAnchorPosition - anchorsTabsHeight && currentScrollPos < scrollAreaEndCoord - anchorsTabsHeight) {
            anchorsContainer.classList.add("fixed", "fixed-show");
            $(anchorsContainer).css("top", headerNavHeight + "px")
        } else {
            anchorsContainer.classList.remove("fixed", "fixed-show");
            $(anchorsContainer).css("top", "unset")
        }
    }

    function makeAnchorsFixed() {
        var anchorsContainer = document.querySelector(".anchor_wrapper-inner:not(.--not-fix)");
        var anchorsWrapper = document.querySelector(".anchor_wrapper");
        updateAnchorsScrollData();
        if (!anchorsContainer) {
            return
        }
        /* Reserve the bar's in-flow height once, so pinning does not collapse the wrapper and jump
           the content below. The about page already locks it in CSS (skip: isTabsMode). Measured
           before any pin, so it is the static height. */
        if (!isTabsMode && !anchorsWrapper.style.height) {
            anchorsWrapper.style.height = anchorsContainer.offsetHeight + "px"
        }
        setFixedAnchorWrapper(anchorsContainer);
        var onScroll = function onScroll() {
            updateAnchorsScrollData();
            setFixedAnchorWrapper(anchorsContainer)
        };
        registerScrollTask(onScroll, false);
        var width = $(window).innerWidth();
        window.addEventListener("resize", function () {
            if ($(window).innerWidth() !== width) {
                width = $(window).innerWidth();
                setTabsHeight()
            }
            setTimeout(function () {
                updateAnchorsScrollData();
                onScroll()
            }, 200)
        })
    }/* - - - - - - - - - - - - - -       init article content text   - - - - - - - - - - - - - - - */
    function initLeftSideTextImages() {
        var clean = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var leftCol = document.querySelector(".article_page .article_page-image-inner");
        var images = document.querySelectorAll(".article_page .text_content h3+img");
        var titleMarginBottom;
        if (clean) $(leftCol).empty();
        $(".article_page .text_content").css("height", "auto");
        if (!leftCol || !images) {
            return
        }
        if (window.innerWidth <= 1024) {
            return
        }
        var newImages = [];
        var parentEl = document.querySelector(".article_page-content-inner");
        var parentOffset = (parentEl === null || parentEl === void 0 ? void 0 : parentEl.getBoundingClientRect().top) + window.scrollY;
        if (!clean) {
            var existImages = document.querySelectorAll(".article_page .article_page-image-inner img");
            existImages === null || existImages === void 0 || existImages.forEach(function (image) {
                return newImages.push(image)
            })
        }
        images.forEach(function (elem, i) {
            if (clean) {
                elem.dataset.index = "initital-image-".concat(i);
                var img = document.createElement("img");
                img.src = elem.src;
                img.alt = elem.alt;
                img.classList.add("article_left-img");
                img.dataset.index = "initital-image-".concat(i);
                if (!img.classList.contains("img")) {
                    img.addEventListener("load", function () {
                        return initLeftSideTextImages(false)
                    })
                }
                img.classList.add("load-listener");
                titleMarginBottom = titleMarginBottom ? titleMarginBottom : $(elem).prev().innerHeight() + parseFloat($(elem).prev().css("margin-bottom"));
                var top = elem.getBoundingClientRect().top + window.scrollY - parentOffset - titleMarginBottom;
                img.style.top = top + "px";
                newImages.push(img)
            } else {
                var _img = newImages.find(function (image) {
                    return image.dataset.index == elem.dataset.index
                });
                if (!_img) return;
                titleMarginBottom = titleMarginBottom ? titleMarginBottom : $(elem).prev().innerHeight() + parseFloat($(elem).prev().css("margin-bottom"));
                var _top = elem.getBoundingClientRect().top + window.scrollY - parentOffset - titleMarginBottom;
                _img.style.top = _top + "px"
            }
        });
        leftCol.append.apply(leftCol, newImages);
        setTimeout(function () {
            var newImgs = document.querySelectorAll(".article_page .article_page-image-inner img");// newImgs.forEach((elem, index) => {
            if (!newImgs.length) return;
            var lastImgPosBottom = newImgs[newImgs.length - 1].getBoundingClientRect().bottom + window.scrollY;
            var contentEnd = $(".article_page .text_content")[0].getBoundingClientRect().bottom + window.scrollY;
            if (lastImgPosBottom > contentEnd) {
                var contentHeight = $(".article_page .text_content").innerHeight();
                var ll = lastImgPosBottom - contentEnd;
                $(".article_page .text_content").css("height", ll + contentHeight + "px")
            }
        })
    }

    if ($(".article_page").length) {
        setTimeout(initLeftSideTextImages, 200);
        window.addEventListener("resize", function () {
            return initLeftSideTextImages(false)
        })
    }// $(document).on("click", ".js-awards-section-accordion", function () {
    function loadDeferredAwardBadges(scope) {
        $(scope).find(".awards_section-prize img[data-defer-src]").each(function () {
            this.setAttribute("src", this.getAttribute("data-defer-src"));
            this.removeAttribute("data-defer-src")
        })
    }
    $(document).on("mouseenter touchstart click", ".awards_section-accordion", function () {
        loadDeferredAwardBadges(this)
    });
    $(document).on("click", ".js-awards-section-accordion", function () {
        var parent = $(this).parents(".awards_section-accordion");
        var popup = $("#popup-accordion");
        var year = $(parent).find(".awards_section-accordion-title span").text().trim();
        var title = $(parent).find(".awards_section-accordion-title h3").text().trim();
        // Badges are interaction-deferred (data-defer-src, see render-image.liquid 'defer'):
        // read the real URL from the data attribute; falls back to src for any badge the
        // intent loader below has already promoted (it removes the attribute when it does).
        var awardImg = $(parent).find(".awards_section-prize img");
        var imageSrc = awardImg.attr("data-defer-src") || awardImg.attr("src");
        if (imageSrc && imageSrc.indexOf("data:image/gif") === 0) imageSrc = null; // never ship the placeholder to the popup
        var items = $(parent).find("ul li").map(function () {
            return $(this).text().trim()
        }).get();
        popup.find(".js-popup-accordion-year").text(year);
        popup.find(".js-popup-accordion-subyear").text(year);
        popup.find(".js-popup-accordion-title").text(title);
        if (imageSrc) {
            popup.find(".js-popup-accordion img").attr("src", imageSrc).removeClass("hidden");
            popup.find(".js-popup-accordion-duplicate img").attr("src", imageSrc).removeClass("hidden")
        } else {
            popup.find(".js-popup-accordion img").addClass("hidden");
            popup.find(".js-popup-accordion-duplicate img").addClass("hidden")
        }
        var listContainer = popup.find(".js-popup-accordion-list");
        listContainer.empty();
        items.forEach(function (item) {
            listContainer.append("<li><div>".concat(item, "</div></li>"))
        });
        if (window.lenis) {
            window.lenis.stop()
        }
        popup.addClass("open")
    });
    $(document).on("click", ".js-popup-close", function () {
        var popup = $("#popup-accordion");
        popup.find(".js-popup-accordion-year").text("");
        popup.find(".js-popup-accordion-subyear").text("");
        popup.find(".js-popup-accordion-title").text("");
        popup.find(".js-popup-accordion img").attr("src", "").addClass("hidden");
        popup.find(".popup-accordion__image img").attr("src", "").addClass("hidden");
        popup.find(".js-popup-accordion-list").empty();
        popup.removeClass("open");
        if (window.lenis) {
            window.lenis.start()
        }
    });
    $(".popup-accordion__close").on("click", function (e) {
        e.preventDefault();
        var popup = $("#popup-accordion");
        popup.removeClass("open");
        if (window.lenis) {
            window.lenis.start()
        }
    });

    // Omega RFQ modal: the vendor locks native scroll (overflow:hidden) but never stops
    // Lenis, whose programmatic writes bypass that lock - so wheel over the quote form
    // scrolled the artwork page behind it. Sync Lenis to the modal's visibility, same
    // mechanism as the sidemenu/awards popup above. A dynamically stamped
    // data-lenis-prevent is IGNORED by this Lenis build (measured) - don't switch to it.
    // While stopped we poll, so every close path (X, backdrop, ESC, node removal)
    // restarts Lenis within 500ms even if its click never reaches us.
    var omgLenisStopped = false;
    var omgLenisPoll = null;
    function omgQuoteModalOpen() {
        var bg = document.querySelector(".omgrfq-bg");
        if (!bg) return false;
        var cs = getComputedStyle(bg);
        return cs.display !== "none" && cs.visibility !== "hidden" && bg.getBoundingClientRect().height > 0;
    }
    // A stopped Lenis still preventDefaults every wheel it sees, which kept the form's
    // own overflow container from wheel-scrolling (scrollbar drag worked, wheel did not).
    // Stop propagation AT THE OVERLAY, bubble phase: Omega's inner handlers run first,
    // Lenis on window never sees the event, and the browser's default action scrolls
    // the form natively. No preventDefault here, ever.
    function omgUnblockWheel() {
        var overlay = document.querySelector(".omgrfq-overlay");
        if (!overlay || overlay.__omgWheelFree) return;
        if (overlay === document.body || overlay === document.documentElement) return;
        overlay.__omgWheelFree = true;
        var free = function (e) {
            if (omgLenisStopped) e.stopPropagation();
        };
        overlay.addEventListener("wheel", free, { passive: true });
        overlay.addEventListener("touchmove", free, { passive: true });
    }
    function omgLenisSync() {
        var open = omgQuoteModalOpen();
        if (open && !omgLenisStopped) {
            omgLenisStopped = true;
            omgUnblockWheel();
            if (window.lenis) window.lenis.stop();
            if (!omgLenisPoll) omgLenisPoll = setInterval(omgLenisSync, 500);
        } else if (!open && omgLenisStopped) {
            omgLenisStopped = false;
            clearInterval(omgLenisPoll);
            omgLenisPoll = null;
            // never unlock while another overlay holds its own Lenis stop
            var otherLock = document.querySelector("#popup-accordion.open, .header_nav-mobile_sidemenu.sidemenu-open");
            if (!otherLock && window.lenis) window.lenis.start();
        }
    }
    document.addEventListener("click", function (e) {
        if (!omgLenisStopped && !(e.target.closest && e.target.closest('[class*="omgrfq"]'))) return;
        setTimeout(omgLenisSync, 150);
        setTimeout(omgLenisSync, 700);
    }, true);// // New accordion
    function getAwardsView() {
        $(".awards_section-accordions-view").remove();
        $(".awards_section-accordions").after("<div class=\"awards_section-accordions-view\"></div>");
        var $awardsView = $(".awards_section-accordions-view");
        $(".awards_section-accordion").each(function (i, item) {
            var $this = $(item), $img = $this.find(".awards_section-accordion-content-additional");
            if ($img.length) {
                $img.clone().attr("data-accordion", $this.attr("data-accordion")).appendTo($awardsView)
            }
        })
    }// if ($(".awards_section-accordions").length) {
    function rebuildAwards() {
        $(".awards_section-accordion").each(function () {
            var $accordion = $(this);
            var $accordionContent = $accordion.find(".awards_section-accordion-content");
            var $accordionAdditional = $accordion.find(".awards_section-accordion-content-additional");
            if ($accordionAdditional.length) {
                var $accordionAdditionalDetach = $accordionAdditional.detach();
                if (window.matchMedia("(max-width:1024px)").matches) {
                    $accordionContent.prepend($accordionAdditionalDetach)
                } else {
                    $accordion.append($accordionAdditionalDetach)
                }
            }
        })
    }

    if ($(".awards_section-accordion").length) {
        rebuildAwards();
        $(window).on("resize", rebuildAwards)
    }

    function toggleBulletsCollectionsSlider($this) {
        var count = $this.slides.length;
        var countView = $this.loopedSlides;// const activeIndex = $this.activeIndex;
        var activeIndex = $this.realIndex;
        $this.pagination.bullets.forEach(function (item, i) {
            if (i >= activeIndex - 1 && i < activeIndex + countView) {
                item.classList.add("show")
            } else {
                item.classList.remove("show")
            }// console.log(i, item)
        })
    }

    if (window.innerWidth > 1024) {
        collectionsSlider()
    }
    initRecommendedPostsSlider();
    /* - - - - - - - - - - - - - -       init reviews slider   - - - - - - - - - - - - - - - */
    function updSwiperNumericPagination() {// console.log(this.el)
        document.querySelector(".reviews_section-counter").innerHTML = "<span class=\"reviews_section-counter-current\">" + (this.realIndex + 1) + "</span> \u2014 <span class=\"reviews_section-counter-total\">" + this.slides.length + "</span>"
    }

    /* PERF (desktop TBT): the reviews sliders are below the fold and use the expensive cube/fade effects — defer their init OUT of the page-load window (requestIdleCallback). Self-contained: nothing outside references these instances. On mobile the Swiper stub makes this a harmless no-op. */
    var __initReviewsSliders = function () {
    var reviewsThumbSwiper = new Swiper(".js-review_section-slider", {
        loop: true,
        speed: 500,
        spaceBetween: 0,
        slidesPerView: 1,
        effect: "fade",
        allowTouchMove: false,
        on: {}
    });
    var reviewsSwiper = new Swiper(".js-reviews_section-preview", {
        loop: true,
        speed: 1000,
        spaceBetween: 0,
        slidesPerView: 1,
        effect: "cube",
        cubeEffect: {shadow: false},
        navigation: {nextEl: ".review_slider-next", prevEl: ".review_slider-prev"},
        thumbs: {swiper: reviewsThumbSwiper, autoScrollOffset: 1},
        on: {init: updSwiperNumericPagination, slideChange: updSwiperNumericPagination}
    });
    };
    if (window.requestIdleCallback) { requestIdleCallback(__initReviewsSliders, { timeout: 3000 }); } else { setTimeout(__initReviewsSliders, 200); }/* - - - - - - - - - - - - - -       init count item   - - - - - - - - - - - - - - - */
    var countInputs = $(".count_input");
    if (countInputs.length) {
        countInputs.each(function (i, elem) {
            var input = $(elem).find("input");
            var decBtn = $(elem).find(".count_input-dec");
            var incBtn = $(elem).find(".count_input-inc");
            var inc = function inc() {
                var value = input.val();
                input.val(+value + 1);
                $(decBtn).removeClass("disabled")
            };
            var dec = function dec() {
                var value = input.val();
                if (+value > 0) {
                    input.val(+value - 1)
                } else {
                    input.val(0)
                }
                if (+value > 1) {
                    $(decBtn).removeClass("disabled")
                } else {
                    $(decBtn).addClass("disabled")
                }
            };
            decBtn.on("click", dec);
            decBtn.on("keydown", function (e) {
                if (e.keyCode === 13) {
                    dec()
                }
            });
            incBtn.on("click", inc);
            incBtn.on("keydown", function (e) {
                if (e.keyCode === 13) {
                    inc()
                }
            });
            $(input).on("input", function () {
                if (+$(input).val()) {
                    $(decBtn).removeClass("disabled")
                } else {
                    $(decBtn).addClass("disabled")
                }
            })
        })
    }/* - - - - - - - - - - - - - -       init shop cart page   - - - - - - - - - - - - - - - */
    var cartItems = document.querySelectorAll(".cart_form .cart_form-row.cart_product");
    var submitButtonContainer = document.querySelector(".cart_form .cart_form-footer-submit .submit_btn-wrapp");
    var submitButton = document.querySelector(".cart_form .cart_form-footer-submit .submit_btn-wrapp .shopnow_button");
    var submitButtonTop = 0;

    function refreshShopButtonMetrics() {
        if (!submitButtonContainer) return;
        submitButtonTop = getAbsoluteElementTop(submitButtonContainer)
    }

    if (cartItems.length) {
        var cartTitle = document.querySelector(".cart_page .title_container sup");
        cartTitle.innerHTML = "[".concat(cartItems.length, "]");
        refreshShopButtonMetrics();
        setShopButtonFixed();
        registerScrollTask(setShopButtonFixed, false);
        registerResizeTask(refreshShopButtonMetrics, false);
        registerResizeTask(setShopButtonFixed, false)
    }

    function setShopButtonFixed() {
        if (!submitButtonContainer || !submitButton) return;
        if (window.innerHeight + window.scrollY < submitButtonTop) {
            submitButton.classList.add("submit_fixed")
        } else {
            submitButton.classList.remove("submit_fixed")
        }
    }/* - - - - - - - - - - - - - -       init masonry grid   - - - - - - - - - - - - - - - */
    var masonryGrids = document.querySelectorAll(".masonry_init_layout");
    masonryGrids === null || masonryGrids === void 0 || masonryGrids.forEach(function (grid) {
        var cards = grid.querySelectorAll(".gallery_card");
        var cols = window.innerWidth > 1024 ? 3 : 1;
        var list = document.createElement("div");
        list.classList.add("masonry_grid");
        list.style.opacity = 0;
        grid.insertAdjacentElement("afterend", list);
        for (var i = 0; i < cols; i++) {
            list.innerHTML = list.innerHTML + "<div class=\"col\"></div>"
        }
        var listColumns = list.querySelectorAll(".col");
        cards === null || cards === void 0 || cards.forEach(function (card, i) {
            var col = (i + cols) % cols;
            var item = document.createElement("div");
            item.classList.add("masonry_grid-item");
            item.append(card);
            listColumns[col].append(item)
        });
        list.style.opacity = 1;
        grid.remove()
    });
    /* issue #9: per-card "curtain" reveal removed — was one ScrollTrigger per gallery card
       lifting a dark picture::after overlay (CSS removed too). Images appear instantly. */
    /* - - - - - - - - - - - - - -    init partners slider   - - - - - - - - - - - - - - - */
    var partnersSlider = document.querySelector(".partners_slider");
    if (partnersSlider) {
        initPartnersSlider()
    }

    function initPartnersSlider() {
        swiper = new Swiper(partnersSlider, {slidesPerView: "auto", mousewheelControl: true, mousewheel: true})
    }/* - - - - - - - - - - - - - -    init subscribe form   - - - - - - - - - - - - - - - */
    var subscribeForm = $(".subscribe_section-form form");
    if (subscribeForm.length) {
        var subscribeFormTitle = $(".subscribe_section-form-title");
        var subscribeFormSuccess = $(".subscribe_section-success");
        subscribeForm.on("submit", function (e) {
            e.preventDefault();
            subscribeForm.css("display", "none");
            subscribeFormTitle.css("display", "none");
            subscribeFormSuccess.css("display", "block")
        })
    }/* - - - - - - - - - - - - - -    init contacts page   - - - - - - - - - - - - - - - */
    var contactSlider = document.querySelector(".contacts-wrapper-slider");
    if (contactSlider) {
        var interleaveOffset = .7;
        var contactSwiper = new Swiper(contactSlider, {
            slidesPerView: 1,
            loop: true,
            speed: 1200,
            watchSlidesProgress: true,
            autoplay: {delay: 5000},
            on: {
                progress: function progress(swiper) {
                    var _swiper$slides;
                    (_swiper$slides = swiper.slides) === null || _swiper$slides === void 0 || _swiper$slides.forEach(function (slide) {
                        var card = slide.querySelector(".slide-card");
                        var translate = slide.progress * swiper.width * interleaveOffset;
                        var scale = slide.progress == 0 ? 1 : 1.35;
                        gsap.set(card, {x: translate, scale: scale})
                    })
                }, setTransition: function setTransition(swiper, speed) {
                    var _swiper$slides2;
                    (_swiper$slides2 = swiper.slides) === null || _swiper$slides2 === void 0 || _swiper$slides2.forEach(function (slide) {
                        var card = slide.querySelector(".slide-card");
                        slide.style.transition = "".concat(speed, "ms");
                        if (card) card.style.transition = "".concat(speed, "ms")
                    })
                }
            }
        })
    }/* - - - - - - - - - - - - - -    init marquee   - - - - - - - - - - - - - - - */
    var _window$global2 = window.global, runningAnimation = _window$global2.runningAnimation,
        isMobile = _window$global2.isMobile;
    var isMobileMode = isMobile();
    var runningTextContainer = document.querySelector(".marquee");
    var runningTextWrappers = document.querySelectorAll(".marquee-wrapper");
    if (runningTextContainer && runningTextWrappers.length) {
        var runningTextWrapperClone = document.createElement("div");
        runningTextWrapperClone.append(runningTextWrappers[0].cloneNode(true));
        var initRunningTextAnimation = function initRunningTextAnimation() {
            runningTextContainer.append(runningTextWrapperClone);
            return runningTextAnimation([].concat(_toConsumableArray(Array.from(runningTextWrappers)), [runningTextWrapperClone]), {
                duration: 12000,
                complete: function complete() {
                }
            })
        };
        var animation = initRunningTextAnimation();
        var callback = function callback(entries) {
            if (entries[0].isIntersecting) {
                animation.play()
            } else {
                animation.pause();
                animation.reset()
            }
        };
        var options = {threshold: 0.0002};
        var observer = new IntersectionObserver(callback, options);
        observer.observe(Array.from(runningTextWrappers)[0])
    }/* - - - - - - - - - - - - - -    init shop button animation on cursor move   - - - - - - - - - - - - - - - */
    var cursorButtonContainers = $("[data-cursor-button-container]");

    function initCursorPos(e, el, button) {
        var cursorPosX = e.clientX;
        var cursorPosY = e.clientY;
        var width = button.width();
        var height = button.height();
        var scrollTop = $(document).scrollTop();
        var boxLeft = el[0].getBoundingClientRect().left;
        var boxTop = el[0].getBoundingClientRect().top;
        var boxBottom = el[0].getBoundingClientRect().bottom;
        var boxRight = el[0].getBoundingClientRect().right;// eslint-disable-next-line no-nested-ternary
        button.css("left", cursorPosX - width / 2 <= boxLeft ? 0 : cursorPosX + width / 2 >= boxRight ? boxRight - width - boxLeft : cursorPosX - width / 2 - boxLeft + "px");// eslint-disable-next-line no-nested-ternary
        button.css("top", cursorPosY - height / 2 <= boxTop ? 0 : cursorPosY + height / 2 >= boxBottom ? boxBottom - boxTop - height : cursorPosY - boxTop - height / 2 + "px");
        button.css("bottom", "unset")
    }

    if (cursorButtonContainers.length) {
        cursorButtonContainers.each(function (i, elem) {
            var button = $(elem).find("[data-cursor-button]");
            var el = $(elem);
            var all = $(elem).find(".shopnow_button *");
            elem.addEventListener("mousemove", function (e) {
                initCursorPos(e, el, button)
            })
        })
    }
});// DISABLE SELECT CHANGE POSITION ON SCROLL
(function ($) {
    var Defaults = $.fn.select2.amd.require("select2/defaults");
    $.extend(Defaults.defaults, {dropdownPosition: "auto"});
    var AttachBody = $.fn.select2.amd.require("select2/dropdown/attachBody");
    var _positionDropdown = AttachBody.prototype._positionDropdown;
    AttachBody.prototype._positionDropdown = function () {
        var $window = $(window);
        var isCurrentlyAbove = this.$dropdown.hasClass("select2-dropdown--above");
        var isCurrentlyBelow = this.$dropdown.hasClass("select2-dropdown--below");
        var newDirection = null;
        var offset = this.$container.offset();
        offset.bottom = offset.top + this.$container.outerHeight(false);
        var container = {height: this.$container.outerHeight(false)};
        container.top = offset.top;
        container.bottom = offset.top + container.height;
        var dropdown = {height: this.$dropdown.outerHeight(false)};
        var viewport = {top: $window.scrollTop(), bottom: $window.scrollTop() + $window.height()};
        var enoughRoomAbove = viewport.top < offset.top - dropdown.height;
        var enoughRoomBelow = viewport.bottom > offset.bottom + dropdown.height;
        var css = {left: offset.left, top: container.bottom};// Determine what the parent element is to use for calciulating the offset
        var $offsetParent = this.$dropdownParent;// For statically positoned elements, we need to get the element
// that is determining the offset
        if ($offsetParent.css("position") === "static") {
            $offsetParent = $offsetParent.offsetParent()
        }
        var parentOffset = $offsetParent.offset();
        css.top -= parentOffset.top;
        css.left -= parentOffset.left;
        var dropdownPositionOption = this.options.get("dropdownPosition");
        if (dropdownPositionOption === "above" || dropdownPositionOption === "below") {
            newDirection = dropdownPositionOption
        } else {
            if (!isCurrentlyAbove && !isCurrentlyBelow) {
                newDirection = "below"
            }
            if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
                newDirection = "above"
            } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
                newDirection = "below"
            }
        }
        if (newDirection == "above" || isCurrentlyAbove && newDirection !== "below") {
            css.top = container.top - parentOffset.top - dropdown.height
        }
        if (newDirection != null) {
            this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + newDirection);
            this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + newDirection)
        }
        this.$dropdownContainer.css(css)
    }
})(window.jQuery);//select on PDP
$(document).ready(function () {
    var accordionItems = document.querySelectorAll(".accordion-select");
    accordionItems.forEach(function (item) {
        item.addEventListener("click", function (e) {
            if (e.target.closest(".product_form-header")) {
                e.target.closest(".accordion-select").classList.toggle("active");
                if (e.target.closest(".accordion-select").classList.contains("active")) {
                    document.addEventListener("click", function (a) {
                        if (!a.target.closest(".product_form-row.accordion-select")) {
                            e.target.closest(".accordion-select").classList.remove("active")
                        }
                    })
                }
            }
            if (e.target.closest(".product_form-dropdown-list-item")) {
                item.querySelector("input").addEventListener("change", function (e) {
                    if (e.target.closest(".product_form-dropdown-list-item")) {// e.preventDefault();
                        item.querySelectorAll(".product_form-dropdown-list-item.active").forEach(function (it) {
                            it.classList.remove("active")
                        });
                        e.target.closest(".product_form-dropdown-list-item").classList.add("active");
                        var checkedValue = e.target.closest(".product_form-dropdown-list-item").querySelector("input").value;
                        item.querySelector(".product_form-header_title").textContent = checkedValue;
                        e.target.closest(".accordion-select").classList.toggle("active");
                        e.target.closest(".accordion-select").classList.add("checked")
                    }
                })
            }
        })
    });//cursor part
    $(document).on("select2:open", function () {
        setTimeout(function () {
            var optionsList = document.querySelector(".select2-results__options");
            // Пример: повесить курсор на каждый элемент списка
            optionsList === null || optionsList === void 0 || optionsList.querySelectorAll("li").forEach(function (item) {
                item.addEventListener("mouseenter", function () {
                    cursor.classList.add("is-link")
                });
                item.addEventListener("mouseleave", function () {
                    cursor.classList.remove("is-link")
                })
            })
        }, 0)
    });
    $(document).on("select2:select", function () {
        cursor.classList.remove("is-link", "is-button")
    })
});
//# sourceMappingURL=app.js.map
